// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file enterprise.proto (package Enterprise, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file enterprise.proto.
 */
export const file_enterprise: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
  );

/**
 * @generated from message Enterprise.EnterpriseKeyPairRequest
 */
export type EnterpriseKeyPairRequest = Message<"Enterprise.EnterpriseKeyPairRequest"> & {
  /**
   * @generated from field: bytes enterprisePublicKey = 1;
   */
  enterprisePublicKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedEnterprisePrivateKey = 2;
   */
  encryptedEnterprisePrivateKey: Uint8Array;

  /**
   * @generated from field: Enterprise.KeyType keyType = 3;
   */
  keyType: KeyType;
};

/**
 * Describes the message Enterprise.EnterpriseKeyPairRequest.
 * Use `create(EnterpriseKeyPairRequestSchema)` to create a new message.
 */
export const EnterpriseKeyPairRequestSchema: GenMessage<EnterpriseKeyPairRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 0);

/**
 * @generated from message Enterprise.GetTeamMemberRequest
 */
export type GetTeamMemberRequest = Message<"Enterprise.GetTeamMemberRequest"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;
};

/**
 * Describes the message Enterprise.GetTeamMemberRequest.
 * Use `create(GetTeamMemberRequestSchema)` to create a new message.
 */
export const GetTeamMemberRequestSchema: GenMessage<GetTeamMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 1);

/**
 * @generated from message Enterprise.EnterpriseUser
 */
export type EnterpriseUser = Message<"Enterprise.EnterpriseUser"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string enterpriseUsername = 3;
   */
  enterpriseUsername: string;

  /**
   * @generated from field: bool isShareAdmin = 4;
   */
  isShareAdmin: boolean;

  /**
   * @generated from field: string username = 5;
   */
  username: string;
};

/**
 * Describes the message Enterprise.EnterpriseUser.
 * Use `create(EnterpriseUserSchema)` to create a new message.
 */
export const EnterpriseUserSchema: GenMessage<EnterpriseUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 2);

/**
 * @generated from message Enterprise.GetTeamMemberResponse
 */
export type GetTeamMemberResponse = Message<"Enterprise.GetTeamMemberResponse"> & {
  /**
   * @generated from field: repeated Enterprise.EnterpriseUser enterpriseUser = 1;
   */
  enterpriseUser: EnterpriseUser[];
};

/**
 * Describes the message Enterprise.GetTeamMemberResponse.
 * Use `create(GetTeamMemberResponseSchema)` to create a new message.
 */
export const GetTeamMemberResponseSchema: GenMessage<GetTeamMemberResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 3);

/**
 * @generated from message Enterprise.EnterpriseUserIds
 */
export type EnterpriseUserIds = Message<"Enterprise.EnterpriseUserIds"> & {
  /**
   * @generated from field: repeated int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint[];
};

/**
 * Describes the message Enterprise.EnterpriseUserIds.
 * Use `create(EnterpriseUserIdsSchema)` to create a new message.
 */
export const EnterpriseUserIdsSchema: GenMessage<EnterpriseUserIds> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 4);

/**
 * @generated from message Enterprise.EnterprisePersonalAccount
 */
export type EnterprisePersonalAccount = Message<"Enterprise.EnterprisePersonalAccount"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: bytes OBSOLETE_FIELD = 2;
   */
  OBSOLETEFIELD: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterprisePersonalAccount.
 * Use `create(EnterprisePersonalAccountSchema)` to create a new message.
 */
export const EnterprisePersonalAccountSchema: GenMessage<EnterprisePersonalAccount> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 5);

/**
 * @generated from message Enterprise.EncryptedTeamKeyRequest
 */
export type EncryptedTeamKeyRequest = Message<"Enterprise.EncryptedTeamKeyRequest"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedTeamKey = 2;
   */
  encryptedTeamKey: Uint8Array;

  /**
   * @generated from field: bool force = 3;
   */
  force: boolean;
};

/**
 * Describes the message Enterprise.EncryptedTeamKeyRequest.
 * Use `create(EncryptedTeamKeyRequestSchema)` to create a new message.
 */
export const EncryptedTeamKeyRequestSchema: GenMessage<EncryptedTeamKeyRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 6);

/**
 * @generated from message Enterprise.ReEncryptedData
 */
export type ReEncryptedData = Message<"Enterprise.ReEncryptedData"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string data = 2;
   */
  data: string;
};

/**
 * Describes the message Enterprise.ReEncryptedData.
 * Use `create(ReEncryptedDataSchema)` to create a new message.
 */
export const ReEncryptedDataSchema: GenMessage<ReEncryptedData> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 7);

/**
 * @generated from message Enterprise.ReEncryptedRoleKey
 */
export type ReEncryptedRoleKey = Message<"Enterprise.ReEncryptedRoleKey"> & {
  /**
   * @generated from field: int64 role_id = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: bytes encryptedRoleKey = 2;
   */
  encryptedRoleKey: Uint8Array;
};

/**
 * Describes the message Enterprise.ReEncryptedRoleKey.
 * Use `create(ReEncryptedRoleKeySchema)` to create a new message.
 */
export const ReEncryptedRoleKeySchema: GenMessage<ReEncryptedRoleKey> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 8);

/**
 * @generated from message Enterprise.ReEncryptedUserDataKey
 */
export type ReEncryptedUserDataKey = Message<"Enterprise.ReEncryptedUserDataKey"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes userEncryptedDataKey = 2;
   */
  userEncryptedDataKey: Uint8Array;
};

/**
 * Describes the message Enterprise.ReEncryptedUserDataKey.
 * Use `create(ReEncryptedUserDataKeySchema)` to create a new message.
 */
export const ReEncryptedUserDataKeySchema: GenMessage<ReEncryptedUserDataKey> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 9);

/**
 * @generated from message Enterprise.NodeToManagedCompanyRequest
 */
export type NodeToManagedCompanyRequest = Message<"Enterprise.NodeToManagedCompanyRequest"> & {
  /**
   * @generated from field: int32 companyId = 1;
   */
  companyId: number;

  /**
   * @generated from field: repeated Enterprise.ReEncryptedData nodes = 2;
   */
  nodes: ReEncryptedData[];

  /**
   * @generated from field: repeated Enterprise.ReEncryptedData roles = 3;
   */
  roles: ReEncryptedData[];

  /**
   * @generated from field: repeated Enterprise.ReEncryptedData users = 4;
   */
  users: ReEncryptedData[];

  /**
   * @generated from field: repeated Enterprise.ReEncryptedRoleKey roleKeys = 5;
   */
  roleKeys: ReEncryptedRoleKey[];

  /**
   * @generated from field: repeated Enterprise.EncryptedTeamKeyRequest teamKeys = 6;
   */
  teamKeys: EncryptedTeamKeyRequest[];

  /**
   * @generated from field: repeated Enterprise.ReEncryptedUserDataKey usersDataKeys = 7;
   */
  usersDataKeys: ReEncryptedUserDataKey[];
};

/**
 * Describes the message Enterprise.NodeToManagedCompanyRequest.
 * Use `create(NodeToManagedCompanyRequestSchema)` to create a new message.
 */
export const NodeToManagedCompanyRequestSchema: GenMessage<NodeToManagedCompanyRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 10);

/**
 * @generated from message Enterprise.RoleTeam
 */
export type RoleTeam = Message<"Enterprise.RoleTeam"> & {
  /**
   * @generated from field: int64 role_id = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: bytes teamUid = 2;
   */
  teamUid: Uint8Array;
};

/**
 * Describes the message Enterprise.RoleTeam.
 * Use `create(RoleTeamSchema)` to create a new message.
 */
export const RoleTeamSchema: GenMessage<RoleTeam> = /*@__PURE__*/ messageDesc(file_enterprise, 11);

/**
 * @generated from message Enterprise.RoleTeams
 */
export type RoleTeams = Message<"Enterprise.RoleTeams"> & {
  /**
   * @generated from field: repeated Enterprise.RoleTeam role_team = 1;
   */
  roleTeam: RoleTeam[];
};

/**
 * Describes the message Enterprise.RoleTeams.
 * Use `create(RoleTeamsSchema)` to create a new message.
 */
export const RoleTeamsSchema: GenMessage<RoleTeams> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 12);

/**
 * @generated from message Enterprise.RoleUserAddKeys
 */
export type RoleUserAddKeys = Message<"Enterprise.RoleUserAddKeys"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string treeKey = 2;
   */
  treeKey: string;

  /**
   * @generated from field: string roleAdminKey = 3;
   */
  roleAdminKey: string;
};

/**
 * Describes the message Enterprise.RoleUserAddKeys.
 * Use `create(RoleUserAddKeysSchema)` to create a new message.
 */
export const RoleUserAddKeysSchema: GenMessage<RoleUserAddKeys> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 13);

/**
 * @generated from message Enterprise.RoleUserAdd
 */
export type RoleUserAdd = Message<"Enterprise.RoleUserAdd"> & {
  /**
   * @generated from field: int64 role_id = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: repeated Enterprise.RoleUserAddKeys roleUserAddKeys = 2;
   */
  roleUserAddKeys: RoleUserAddKeys[];
};

/**
 * Describes the message Enterprise.RoleUserAdd.
 * Use `create(RoleUserAddSchema)` to create a new message.
 */
export const RoleUserAddSchema: GenMessage<RoleUserAdd> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 14);

/**
 * @generated from message Enterprise.RoleUsersAddRequest
 */
export type RoleUsersAddRequest = Message<"Enterprise.RoleUsersAddRequest"> & {
  /**
   * @generated from field: repeated Enterprise.RoleUserAdd roleUserAdds = 1;
   */
  roleUserAdds: RoleUserAdd[];
};

/**
 * Describes the message Enterprise.RoleUsersAddRequest.
 * Use `create(RoleUsersAddRequestSchema)` to create a new message.
 */
export const RoleUsersAddRequestSchema: GenMessage<RoleUsersAddRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 15);

/**
 * @generated from message Enterprise.RoleUserAddResult
 */
export type RoleUserAddResult = Message<"Enterprise.RoleUserAddResult"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: Enterprise.RoleUserModifyStatus status = 3;
   */
  status: RoleUserModifyStatus;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Enterprise.RoleUserAddResult.
 * Use `create(RoleUserAddResultSchema)` to create a new message.
 */
export const RoleUserAddResultSchema: GenMessage<RoleUserAddResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 16);

/**
 * @generated from message Enterprise.RoleUsersAddResponse
 */
export type RoleUsersAddResponse = Message<"Enterprise.RoleUsersAddResponse"> & {
  /**
   * @generated from field: repeated Enterprise.RoleUserAddResult results = 1;
   */
  results: RoleUserAddResult[];
};

/**
 * Describes the message Enterprise.RoleUsersAddResponse.
 * Use `create(RoleUsersAddResponseSchema)` to create a new message.
 */
export const RoleUsersAddResponseSchema: GenMessage<RoleUsersAddResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 17);

/**
 * @generated from message Enterprise.RoleUserRemove
 */
export type RoleUserRemove = Message<"Enterprise.RoleUserRemove"> & {
  /**
   * @generated from field: int64 role_id = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: repeated int64 enterpriseUserIds = 2;
   */
  enterpriseUserIds: bigint[];
};

/**
 * Describes the message Enterprise.RoleUserRemove.
 * Use `create(RoleUserRemoveSchema)` to create a new message.
 */
export const RoleUserRemoveSchema: GenMessage<RoleUserRemove> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 18);

/**
 * @generated from message Enterprise.RoleUsersRemoveRequest
 */
export type RoleUsersRemoveRequest = Message<"Enterprise.RoleUsersRemoveRequest"> & {
  /**
   * @generated from field: repeated Enterprise.RoleUserRemove roleUserRemoves = 1;
   */
  roleUserRemoves: RoleUserRemove[];
};

/**
 * Describes the message Enterprise.RoleUsersRemoveRequest.
 * Use `create(RoleUsersRemoveRequestSchema)` to create a new message.
 */
export const RoleUsersRemoveRequestSchema: GenMessage<RoleUsersRemoveRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 19);

/**
 * @generated from message Enterprise.RoleUserRemoveResult
 */
export type RoleUserRemoveResult = Message<"Enterprise.RoleUserRemoveResult"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: Enterprise.RoleUserModifyStatus status = 3;
   */
  status: RoleUserModifyStatus;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Enterprise.RoleUserRemoveResult.
 * Use `create(RoleUserRemoveResultSchema)` to create a new message.
 */
export const RoleUserRemoveResultSchema: GenMessage<RoleUserRemoveResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 20);

/**
 * @generated from message Enterprise.RoleUsersRemoveResponse
 */
export type RoleUsersRemoveResponse = Message<"Enterprise.RoleUsersRemoveResponse"> & {
  /**
   * @generated from field: repeated Enterprise.RoleUserRemoveResult results = 1;
   */
  results: RoleUserRemoveResult[];
};

/**
 * Describes the message Enterprise.RoleUsersRemoveResponse.
 * Use `create(RoleUsersRemoveResponseSchema)` to create a new message.
 */
export const RoleUsersRemoveResponseSchema: GenMessage<RoleUsersRemoveResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 21);

/**
 * @generated from message Enterprise.EnterpriseRegistration
 */
export type EnterpriseRegistration = Message<"Enterprise.EnterpriseRegistration"> & {
  /**
   * @generated from field: bytes encryptedTreeKey = 1;
   */
  encryptedTreeKey: Uint8Array;

  /**
   * @generated from field: string enterpriseName = 2;
   */
  enterpriseName: string;

  /**
   * @generated from field: bytes rootNodeData = 3;
   */
  rootNodeData: Uint8Array;

  /**
   * @generated from field: bytes adminUserData = 4;
   */
  adminUserData: Uint8Array;

  /**
   * @generated from field: string adminName = 5;
   */
  adminName: string;

  /**
   * @generated from field: bytes roleData = 6;
   */
  roleData: Uint8Array;

  /**
   * @generated from field: Enterprise.EnterpriseKeyPairRequest rsaKeyPair = 7;
   */
  rsaKeyPair?: EnterpriseKeyPairRequest;

  /**
   * @generated from field: int32 numberSeats = 8;
   */
  numberSeats: number;

  /**
   * @generated from field: Enterprise.EnterpriseType enterpriseType = 9;
   */
  enterpriseType: EnterpriseType;

  /**
   * @generated from field: bytes rolePublicKey = 10;
   */
  rolePublicKey: Uint8Array;

  /**
   * @generated from field: bytes rolePrivateKeyEncryptedWithRoleKey = 11;
   */
  rolePrivateKeyEncryptedWithRoleKey: Uint8Array;

  /**
   * @generated from field: bytes roleKeyEncryptedWithTreeKey = 12;
   */
  roleKeyEncryptedWithTreeKey: Uint8Array;

  /**
   * @generated from field: Enterprise.EnterpriseKeyPairRequest eccKeyPair = 13;
   */
  eccKeyPair?: EnterpriseKeyPairRequest;

  /**
   * @generated from field: bytes allUsersRoleData = 14;
   */
  allUsersRoleData: Uint8Array;

  /**
   * @generated from field: bytes roleKeyEncryptedWithUserPublicKey = 15;
   */
  roleKeyEncryptedWithUserPublicKey: Uint8Array;

  /**
   * @generated from field: bytes approverRoleData = 16;
   */
  approverRoleData: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterpriseRegistration.
 * Use `create(EnterpriseRegistrationSchema)` to create a new message.
 */
export const EnterpriseRegistrationSchema: GenMessage<EnterpriseRegistration> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 22);

/**
 * @generated from message Enterprise.DomainPasswordRulesRequest
 */
export type DomainPasswordRulesRequest = Message<"Enterprise.DomainPasswordRulesRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string verificationCode = 2;
   */
  verificationCode: string;
};

/**
 * Describes the message Enterprise.DomainPasswordRulesRequest.
 * Use `create(DomainPasswordRulesRequestSchema)` to create a new message.
 */
export const DomainPasswordRulesRequestSchema: GenMessage<DomainPasswordRulesRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 23);

/**
 * @generated from message Enterprise.DomainPasswordRulesFields
 */
export type DomainPasswordRulesFields = Message<"Enterprise.DomainPasswordRulesFields"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int32 minimum = 2;
   */
  minimum: number;

  /**
   * @generated from field: int32 maximum = 3;
   */
  maximum: number;

  /**
   * @generated from field: bool allowed = 4;
   */
  allowed: boolean;
};

/**
 * Describes the message Enterprise.DomainPasswordRulesFields.
 * Use `create(DomainPasswordRulesFieldsSchema)` to create a new message.
 */
export const DomainPasswordRulesFieldsSchema: GenMessage<DomainPasswordRulesFields> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 24);

/**
 * @generated from message Enterprise.LoginToMcRequest
 */
export type LoginToMcRequest = Message<"Enterprise.LoginToMcRequest"> & {
  /**
   * @generated from field: int32 mcEnterpriseId = 1;
   */
  mcEnterpriseId: number;

  /**
   * @generated from field: bytes messageSessionUid = 2;
   */
  messageSessionUid: Uint8Array;
};

/**
 * Describes the message Enterprise.LoginToMcRequest.
 * Use `create(LoginToMcRequestSchema)` to create a new message.
 */
export const LoginToMcRequestSchema: GenMessage<LoginToMcRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 25);

/**
 * @generated from message Enterprise.LoginToMcResponse
 */
export type LoginToMcResponse = Message<"Enterprise.LoginToMcResponse"> & {
  /**
   * @generated from field: bytes encryptedSessionToken = 1;
   */
  encryptedSessionToken: Uint8Array;

  /**
   * @generated from field: string encryptedTreeKey = 2;
   */
  encryptedTreeKey: string;
};

/**
 * Describes the message Enterprise.LoginToMcResponse.
 * Use `create(LoginToMcResponseSchema)` to create a new message.
 */
export const LoginToMcResponseSchema: GenMessage<LoginToMcResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 26);

/**
 * @generated from message Enterprise.DomainPasswordRulesResponse
 */
export type DomainPasswordRulesResponse = Message<"Enterprise.DomainPasswordRulesResponse"> & {
  /**
   * @generated from field: repeated Enterprise.DomainPasswordRulesFields domainPasswordRulesFields = 1;
   */
  domainPasswordRulesFields: DomainPasswordRulesFields[];
};

/**
 * Describes the message Enterprise.DomainPasswordRulesResponse.
 * Use `create(DomainPasswordRulesResponseSchema)` to create a new message.
 */
export const DomainPasswordRulesResponseSchema: GenMessage<DomainPasswordRulesResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 27);

/**
 * @generated from message Enterprise.ApproveUserDeviceRequest
 */
export type ApproveUserDeviceRequest = Message<"Enterprise.ApproveUserDeviceRequest"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedDeviceToken = 2;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceDataKey = 3;
   */
  encryptedDeviceDataKey: Uint8Array;

  /**
   * @generated from field: bool denyApproval = 4;
   */
  denyApproval: boolean;
};

/**
 * Describes the message Enterprise.ApproveUserDeviceRequest.
 * Use `create(ApproveUserDeviceRequestSchema)` to create a new message.
 */
export const ApproveUserDeviceRequestSchema: GenMessage<ApproveUserDeviceRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 28);

/**
 * @generated from message Enterprise.ApproveUserDeviceResponse
 */
export type ApproveUserDeviceResponse = Message<"Enterprise.ApproveUserDeviceResponse"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedDeviceToken = 2;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bool failed = 3;
   */
  failed: boolean;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Enterprise.ApproveUserDeviceResponse.
 * Use `create(ApproveUserDeviceResponseSchema)` to create a new message.
 */
export const ApproveUserDeviceResponseSchema: GenMessage<ApproveUserDeviceResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 29);

/**
 * @generated from message Enterprise.ApproveUserDevicesRequest
 */
export type ApproveUserDevicesRequest = Message<"Enterprise.ApproveUserDevicesRequest"> & {
  /**
   * @generated from field: repeated Enterprise.ApproveUserDeviceRequest deviceRequests = 1;
   */
  deviceRequests: ApproveUserDeviceRequest[];
};

/**
 * Describes the message Enterprise.ApproveUserDevicesRequest.
 * Use `create(ApproveUserDevicesRequestSchema)` to create a new message.
 */
export const ApproveUserDevicesRequestSchema: GenMessage<ApproveUserDevicesRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 30);

/**
 * @generated from message Enterprise.ApproveUserDevicesResponse
 */
export type ApproveUserDevicesResponse = Message<"Enterprise.ApproveUserDevicesResponse"> & {
  /**
   * @generated from field: repeated Enterprise.ApproveUserDeviceResponse deviceResponses = 1;
   */
  deviceResponses: ApproveUserDeviceResponse[];
};

/**
 * Describes the message Enterprise.ApproveUserDevicesResponse.
 * Use `create(ApproveUserDevicesResponseSchema)` to create a new message.
 */
export const ApproveUserDevicesResponseSchema: GenMessage<ApproveUserDevicesResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 31);

/**
 * @generated from message Enterprise.EnterpriseUserDataKey
 */
export type EnterpriseUserDataKey = Message<"Enterprise.EnterpriseUserDataKey"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes userEncryptedDataKey = 2;
   */
  userEncryptedDataKey: Uint8Array;

  /**
   * @generated from field: int32 keyTypeId = 3;
   */
  keyTypeId: number;

  /**
   * @generated from field: bytes roleKey = 4;
   */
  roleKey: Uint8Array;

  /**
   * @generated from field: bytes privateKey = 5;
   */
  privateKey: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterpriseUserDataKey.
 * Use `create(EnterpriseUserDataKeySchema)` to create a new message.
 */
export const EnterpriseUserDataKeySchema: GenMessage<EnterpriseUserDataKey> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 32);

/**
 * @generated from message Enterprise.EnterpriseUserDataKeys
 */
export type EnterpriseUserDataKeys = Message<"Enterprise.EnterpriseUserDataKeys"> & {
  /**
   * @generated from field: repeated Enterprise.EnterpriseUserDataKey keys = 1;
   */
  keys: EnterpriseUserDataKey[];
};

/**
 * Describes the message Enterprise.EnterpriseUserDataKeys.
 * Use `create(EnterpriseUserDataKeysSchema)` to create a new message.
 */
export const EnterpriseUserDataKeysSchema: GenMessage<EnterpriseUserDataKeys> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 33);

/**
 * @generated from message Enterprise.EnterpriseUserDataKeyLight
 */
export type EnterpriseUserDataKeyLight = Message<"Enterprise.EnterpriseUserDataKeyLight"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes userEncryptedDataKey = 2;
   */
  userEncryptedDataKey: Uint8Array;

  /**
   * @generated from field: int32 keyTypeId = 3;
   */
  keyTypeId: number;
};

/**
 * Describes the message Enterprise.EnterpriseUserDataKeyLight.
 * Use `create(EnterpriseUserDataKeyLightSchema)` to create a new message.
 */
export const EnterpriseUserDataKeyLightSchema: GenMessage<EnterpriseUserDataKeyLight> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 34);

/**
 * @generated from message Enterprise.EnterpriseUserDataKeysByNode
 */
export type EnterpriseUserDataKeysByNode = Message<"Enterprise.EnterpriseUserDataKeysByNode"> & {
  /**
   * @generated from field: int64 nodeId = 1;
   */
  nodeId: bigint;

  /**
   * @generated from field: repeated Enterprise.EnterpriseUserDataKeyLight keys = 2;
   */
  keys: EnterpriseUserDataKeyLight[];
};

/**
 * Describes the message Enterprise.EnterpriseUserDataKeysByNode.
 * Use `create(EnterpriseUserDataKeysByNodeSchema)` to create a new message.
 */
export const EnterpriseUserDataKeysByNodeSchema: GenMessage<EnterpriseUserDataKeysByNode> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 35);

/**
 * @generated from message Enterprise.EnterpriseUserDataKeysByNodeResponse
 */
export type EnterpriseUserDataKeysByNodeResponse =
  Message<"Enterprise.EnterpriseUserDataKeysByNodeResponse"> & {
    /**
     * @generated from field: repeated Enterprise.EnterpriseUserDataKeysByNode keys = 1;
     */
    keys: EnterpriseUserDataKeysByNode[];
  };

/**
 * Describes the message Enterprise.EnterpriseUserDataKeysByNodeResponse.
 * Use `create(EnterpriseUserDataKeysByNodeResponseSchema)` to create a new message.
 */
export const EnterpriseUserDataKeysByNodeResponseSchema: GenMessage<EnterpriseUserDataKeysByNodeResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 36);

/**
 * @generated from message Enterprise.EnterpriseDataRequest
 */
export type EnterpriseDataRequest = Message<"Enterprise.EnterpriseDataRequest"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterpriseDataRequest.
 * Use `create(EnterpriseDataRequestSchema)` to create a new message.
 */
export const EnterpriseDataRequestSchema: GenMessage<EnterpriseDataRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 37);

/**
 * @generated from message Enterprise.SpecialProvisioning
 */
export type SpecialProvisioning = Message<"Enterprise.SpecialProvisioning"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message Enterprise.SpecialProvisioning.
 * Use `create(SpecialProvisioningSchema)` to create a new message.
 */
export const SpecialProvisioningSchema: GenMessage<SpecialProvisioning> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 38);

/**
 * @generated from message Enterprise.GeneralDataEntity
 */
export type GeneralDataEntity = Message<"Enterprise.GeneralDataEntity"> & {
  /**
   * @generated from field: string enterpriseName = 1;
   */
  enterpriseName: string;

  /**
   * @generated from field: bool restrictVisibility = 2;
   */
  restrictVisibility: boolean;

  /**
   * @generated from field: Enterprise.SpecialProvisioning specialProvisioning = 4;
   */
  specialProvisioning?: SpecialProvisioning;

  /**
   * @generated from field: Enterprise.UserPrivilege userPrivilege = 7;
   */
  userPrivilege?: UserPrivilege;

  /**
   * @generated from field: bool distributor = 8;
   */
  distributor: boolean;

  /**
   * @generated from field: bool forbidAccountTransfer = 9;
   */
  forbidAccountTransfer: boolean;

  /**
   * @generated from field: bool showUserOnboard = 10;
   */
  showUserOnboard: boolean;
};

/**
 * Describes the message Enterprise.GeneralDataEntity.
 * Use `create(GeneralDataEntitySchema)` to create a new message.
 */
export const GeneralDataEntitySchema: GenMessage<GeneralDataEntity> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 39);

/**
 * @generated from message Enterprise.Node
 */
export type Node = Message<"Enterprise.Node"> & {
  /**
   * @generated from field: int64 nodeId = 1;
   */
  nodeId: bigint;

  /**
   * @generated from field: int64 parentId = 2;
   */
  parentId: bigint;

  /**
   * @generated from field: int64 bridgeId = 3;
   */
  bridgeId: bigint;

  /**
   * @generated from field: int64 scimId = 4;
   */
  scimId: bigint;

  /**
   * @generated from field: int64 licenseId = 5;
   */
  licenseId: bigint;

  /**
   * @generated from field: string encryptedData = 6;
   */
  encryptedData: string;

  /**
   * @generated from field: bool duoEnabled = 7;
   */
  duoEnabled: boolean;

  /**
   * @generated from field: bool rsaEnabled = 8;
   */
  rsaEnabled: boolean;

  /**
   * @generated from field: int64 ssoServiceProviderId = 9;
   */
  ssoServiceProviderId: bigint;

  /**
   * @generated from field: bool restrictVisibility = 10;
   */
  restrictVisibility: boolean;

  /**
   * @generated from field: repeated int64 ssoServiceProviderIds = 11;
   */
  ssoServiceProviderIds: bigint[];
};

/**
 * Describes the message Enterprise.Node.
 * Use `create(NodeSchema)` to create a new message.
 */
export const NodeSchema: GenMessage<Node> = /*@__PURE__*/ messageDesc(file_enterprise, 40);

/**
 * @generated from message Enterprise.Role
 */
export type Role = Message<"Enterprise.Role"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string encryptedData = 3;
   */
  encryptedData: string;

  /**
   * @generated from field: string keyType = 4;
   */
  keyType: string;

  /**
   * @generated from field: bool visibleBelow = 5;
   */
  visibleBelow: boolean;

  /**
   * @generated from field: bool newUserInherit = 6;
   */
  newUserInherit: boolean;

  /**
   * @generated from field: string roleType = 7;
   */
  roleType: string;
};

/**
 * Describes the message Enterprise.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/ messageDesc(file_enterprise, 41);

/**
 * @generated from message Enterprise.User
 */
export type User = Message<"Enterprise.User"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string encryptedData = 3;
   */
  encryptedData: string;

  /**
   * @generated from field: string keyType = 4;
   */
  keyType: string;

  /**
   * @generated from field: string username = 5;
   */
  username: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int32 lock = 7;
   */
  lock: number;

  /**
   * @generated from field: int32 userId = 8;
   */
  userId: number;

  /**
   * @generated from field: int64 accountShareExpiration = 9;
   */
  accountShareExpiration: bigint;

  /**
   * @generated from field: string fullName = 10;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 11;
   */
  jobTitle: string;

  /**
   * @generated from field: bool tfaEnabled = 12;
   */
  tfaEnabled: boolean;

  /**
   * @generated from field: Enterprise.TransferAcceptanceStatus transferAcceptanceStatus = 13;
   */
  transferAcceptanceStatus: TransferAcceptanceStatus;
};

/**
 * Describes the message Enterprise.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/ messageDesc(file_enterprise, 42);

/**
 * @generated from message Enterprise.UserAlias
 */
export type UserAlias = Message<"Enterprise.UserAlias"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string username = 2;
   */
  username: string;
};

/**
 * Describes the message Enterprise.UserAlias.
 * Use `create(UserAliasSchema)` to create a new message.
 */
export const UserAliasSchema: GenMessage<UserAlias> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 43);

/**
 * @generated from message Enterprise.ComplianceReportMetaData
 */
export type ComplianceReportMetaData = Message<"Enterprise.ComplianceReportMetaData"> & {
  /**
   * @generated from field: bytes reportUid = 1;
   */
  reportUid: Uint8Array;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string reportName = 3;
   */
  reportName: string;

  /**
   * @generated from field: int64 dateGenerated = 4;
   */
  dateGenerated: bigint;

  /**
   * @generated from field: string runByName = 5;
   */
  runByName: string;

  /**
   * @generated from field: int32 numberOfOwners = 7;
   */
  numberOfOwners: number;

  /**
   * @generated from field: int32 numberOfRecords = 8;
   */
  numberOfRecords: number;
};

/**
 * Describes the message Enterprise.ComplianceReportMetaData.
 * Use `create(ComplianceReportMetaDataSchema)` to create a new message.
 */
export const ComplianceReportMetaDataSchema: GenMessage<ComplianceReportMetaData> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 44);

/**
 * @generated from message Enterprise.ManagedNode
 */
export type ManagedNode = Message<"Enterprise.ManagedNode"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: int64 managedNodeId = 2;
   */
  managedNodeId: bigint;

  /**
   * @generated from field: bool cascadeNodeManagement = 3;
   */
  cascadeNodeManagement: boolean;
};

/**
 * Describes the message Enterprise.ManagedNode.
 * Use `create(ManagedNodeSchema)` to create a new message.
 */
export const ManagedNodeSchema: GenMessage<ManagedNode> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 45);

/**
 * @generated from message Enterprise.UserManagedNode
 */
export type UserManagedNode = Message<"Enterprise.UserManagedNode"> & {
  /**
   * @generated from field: int64 nodeId = 1;
   */
  nodeId: bigint;

  /**
   * @generated from field: bool cascadeNodeManagement = 2;
   */
  cascadeNodeManagement: boolean;

  /**
   * @generated from field: repeated string privileges = 3;
   */
  privileges: string[];
};

/**
 * Describes the message Enterprise.UserManagedNode.
 * Use `create(UserManagedNodeSchema)` to create a new message.
 */
export const UserManagedNodeSchema: GenMessage<UserManagedNode> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 46);

/**
 * @generated from message Enterprise.UserPrivilege
 */
export type UserPrivilege = Message<"Enterprise.UserPrivilege"> & {
  /**
   * @generated from field: repeated Enterprise.UserManagedNode userManagedNodes = 1;
   */
  userManagedNodes: UserManagedNode[];

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string encryptedData = 3;
   */
  encryptedData: string;
};

/**
 * Describes the message Enterprise.UserPrivilege.
 * Use `create(UserPrivilegeSchema)` to create a new message.
 */
export const UserPrivilegeSchema: GenMessage<UserPrivilege> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 47);

/**
 * @generated from message Enterprise.RoleUser
 */
export type RoleUser = Message<"Enterprise.RoleUser"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;
};

/**
 * Describes the message Enterprise.RoleUser.
 * Use `create(RoleUserSchema)` to create a new message.
 */
export const RoleUserSchema: GenMessage<RoleUser> = /*@__PURE__*/ messageDesc(file_enterprise, 48);

/**
 * @generated from message Enterprise.RolePrivilege
 */
export type RolePrivilege = Message<"Enterprise.RolePrivilege"> & {
  /**
   * @generated from field: int64 managedNodeId = 1;
   */
  managedNodeId: bigint;

  /**
   * @generated from field: int64 roleId = 2;
   */
  roleId: bigint;

  /**
   * @generated from field: string privilegeType = 3;
   */
  privilegeType: string;
};

/**
 * Describes the message Enterprise.RolePrivilege.
 * Use `create(RolePrivilegeSchema)` to create a new message.
 */
export const RolePrivilegeSchema: GenMessage<RolePrivilege> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 49);

/**
 * @generated from message Enterprise.RoleEnforcement
 */
export type RoleEnforcement = Message<"Enterprise.RoleEnforcement"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: string enforcementType = 2;
   */
  enforcementType: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message Enterprise.RoleEnforcement.
 * Use `create(RoleEnforcementSchema)` to create a new message.
 */
export const RoleEnforcementSchema: GenMessage<RoleEnforcement> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 50);

/**
 * @generated from message Enterprise.Team
 */
export type Team = Message<"Enterprise.Team"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 nodeId = 3;
   */
  nodeId: bigint;

  /**
   * @generated from field: bool restrictEdit = 4;
   */
  restrictEdit: boolean;

  /**
   * @generated from field: bool restrictShare = 5;
   */
  restrictShare: boolean;

  /**
   * @generated from field: bool restrictView = 6;
   */
  restrictView: boolean;

  /**
   * @generated from field: string encryptedData = 7;
   */
  encryptedData: string;

  /**
   * @generated from field: string encryptedTeamKey = 8;
   */
  encryptedTeamKey: string;
};

/**
 * Describes the message Enterprise.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/ messageDesc(file_enterprise, 51);

/**
 * @generated from message Enterprise.TeamUser
 */
export type TeamUser = Message<"Enterprise.TeamUser"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string userType = 3;
   */
  userType: string;
};

/**
 * Describes the message Enterprise.TeamUser.
 * Use `create(TeamUserSchema)` to create a new message.
 */
export const TeamUserSchema: GenMessage<TeamUser> = /*@__PURE__*/ messageDesc(file_enterprise, 52);

/**
 * @generated from message Enterprise.GetDistributorInfoResponse
 */
export type GetDistributorInfoResponse = Message<"Enterprise.GetDistributorInfoResponse"> & {
  /**
   * @generated from field: repeated Enterprise.Distributor distributors = 1;
   */
  distributors: Distributor[];
};

/**
 * Describes the message Enterprise.GetDistributorInfoResponse.
 * Use `create(GetDistributorInfoResponseSchema)` to create a new message.
 */
export const GetDistributorInfoResponseSchema: GenMessage<GetDistributorInfoResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 53);

/**
 * @generated from message Enterprise.Distributor
 */
export type Distributor = Message<"Enterprise.Distributor"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated Enterprise.MspInfo mspInfos = 2;
   */
  mspInfos: MspInfo[];
};

/**
 * Describes the message Enterprise.Distributor.
 * Use `create(DistributorSchema)` to create a new message.
 */
export const DistributorSchema: GenMessage<Distributor> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 54);

/**
 * @generated from message Enterprise.MspInfo
 */
export type MspInfo = Message<"Enterprise.MspInfo"> & {
  /**
   * @generated from field: int32 enterpriseId = 1;
   */
  enterpriseId: number;

  /**
   * @generated from field: string enterpriseName = 2;
   */
  enterpriseName: string;

  /**
   * @generated from field: int32 allocatedLicenses = 3;
   */
  allocatedLicenses: number;

  /**
   * @generated from field: repeated string allowedMcProducts = 4;
   */
  allowedMcProducts: string[];

  /**
   * @generated from field: repeated string allowedAddOns = 5;
   */
  allowedAddOns: string[];

  /**
   * @generated from field: string maxFilePlanType = 6;
   */
  maxFilePlanType: string;

  /**
   * @generated from field: repeated Enterprise.ManagedCompany managedCompanies = 7;
   */
  managedCompanies: ManagedCompany[];

  /**
   * @generated from field: bool allowUnlimitedLicenses = 8;
   */
  allowUnlimitedLicenses: boolean;

  /**
   * @generated from field: repeated Enterprise.LicenseAddOn addOns = 9;
   */
  addOns: LicenseAddOn[];
};

/**
 * Describes the message Enterprise.MspInfo.
 * Use `create(MspInfoSchema)` to create a new message.
 */
export const MspInfoSchema: GenMessage<MspInfo> = /*@__PURE__*/ messageDesc(file_enterprise, 55);

/**
 * @generated from message Enterprise.ManagedCompany
 */
export type ManagedCompany = Message<"Enterprise.ManagedCompany"> & {
  /**
   * @generated from field: int32 mcEnterpriseId = 1;
   */
  mcEnterpriseId: number;

  /**
   * @generated from field: string mcEnterpriseName = 2;
   */
  mcEnterpriseName: string;

  /**
   * @generated from field: int64 mspNodeId = 3;
   */
  mspNodeId: bigint;

  /**
   * @generated from field: int32 numberOfSeats = 4;
   */
  numberOfSeats: number;

  /**
   * @generated from field: int32 numberOfUsers = 5;
   */
  numberOfUsers: number;

  /**
   * @generated from field: string productId = 6;
   */
  productId: string;

  /**
   * @generated from field: bool isExpired = 7;
   */
  isExpired: boolean;

  /**
   * @generated from field: string treeKey = 8;
   */
  treeKey: string;

  /**
   * @generated from field: int64 tree_key_role = 9;
   */
  treeKeyRole: bigint;

  /**
   * @generated from field: string filePlanType = 10;
   */
  filePlanType: string;

  /**
   * @generated from field: repeated Enterprise.LicenseAddOn addOns = 11;
   */
  addOns: LicenseAddOn[];
};

/**
 * Describes the message Enterprise.ManagedCompany.
 * Use `create(ManagedCompanySchema)` to create a new message.
 */
export const ManagedCompanySchema: GenMessage<ManagedCompany> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 56);

/**
 * @generated from message Enterprise.MSPPool
 */
export type MSPPool = Message<"Enterprise.MSPPool"> & {
  /**
   * @generated from field: string productId = 1;
   */
  productId: string;

  /**
   * @generated from field: int32 seats = 2;
   */
  seats: number;

  /**
   * @generated from field: int32 availableSeats = 3;
   */
  availableSeats: number;

  /**
   * @generated from field: int32 stash = 4;
   */
  stash: number;
};

/**
 * Describes the message Enterprise.MSPPool.
 * Use `create(MSPPoolSchema)` to create a new message.
 */
export const MSPPoolSchema: GenMessage<MSPPool> = /*@__PURE__*/ messageDesc(file_enterprise, 57);

/**
 * @generated from message Enterprise.MSPContact
 */
export type MSPContact = Message<"Enterprise.MSPContact"> & {
  /**
   * @generated from field: int32 enterpriseId = 1;
   */
  enterpriseId: number;

  /**
   * @generated from field: string enterpriseName = 2;
   */
  enterpriseName: string;
};

/**
 * Describes the message Enterprise.MSPContact.
 * Use `create(MSPContactSchema)` to create a new message.
 */
export const MSPContactSchema: GenMessage<MSPContact> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 58);

/**
 * @generated from message Enterprise.LicenseAddOn
 */
export type LicenseAddOn = Message<"Enterprise.LicenseAddOn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: bool isTrial = 3;
   */
  isTrial: boolean;

  /**
   * @generated from field: int64 expiration = 4;
   */
  expiration: bigint;

  /**
   * @generated from field: int64 created = 5;
   */
  created: bigint;

  /**
   * @generated from field: int32 seats = 6;
   */
  seats: number;

  /**
   * @generated from field: int64 activationTime = 7;
   */
  activationTime: bigint;

  /**
   * @generated from field: bool includedInProduct = 8;
   */
  includedInProduct: boolean;

  /**
   * @generated from field: int32 apiCallCount = 9;
   */
  apiCallCount: number;

  /**
   * @generated from field: string tierDescription = 10;
   */
  tierDescription: string;

  /**
   * @generated from field: int32 seatsAllocated = 11;
   */
  seatsAllocated: number;
};

/**
 * Describes the message Enterprise.LicenseAddOn.
 * Use `create(LicenseAddOnSchema)` to create a new message.
 */
export const LicenseAddOnSchema: GenMessage<LicenseAddOn> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 59);

/**
 * @generated from message Enterprise.MCDefault
 */
export type MCDefault = Message<"Enterprise.MCDefault"> & {
  /**
   * @generated from field: string mcProduct = 1;
   */
  mcProduct: string;

  /**
   * @generated from field: repeated string addOns = 2;
   */
  addOns: string[];

  /**
   * @generated from field: string filePlanType = 3;
   */
  filePlanType: string;

  /**
   * @generated from field: int32 maxLicenses = 4;
   */
  maxLicenses: number;

  /**
   * @generated from field: bool fixedMaxLicenses = 5;
   */
  fixedMaxLicenses: boolean;
};

/**
 * Describes the message Enterprise.MCDefault.
 * Use `create(MCDefaultSchema)` to create a new message.
 */
export const MCDefaultSchema: GenMessage<MCDefault> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 60);

/**
 * @generated from message Enterprise.MSPPermits
 */
export type MSPPermits = Message<"Enterprise.MSPPermits"> & {
  /**
   * @generated from field: bool restricted = 1;
   */
  restricted: boolean;

  /**
   * @generated from field: int32 maxAllowedLicenses = 2;
   */
  maxAllowedLicenses: number;

  /**
   * @generated from field: repeated string allowedMcProducts = 3;
   */
  allowedMcProducts: string[];

  /**
   * @generated from field: repeated string allowedAddOns = 4;
   */
  allowedAddOns: string[];

  /**
   * @generated from field: string maxFilePlanType = 5;
   */
  maxFilePlanType: string;

  /**
   * @generated from field: bool allowUnlimitedLicenses = 6;
   */
  allowUnlimitedLicenses: boolean;

  /**
   * @generated from field: repeated Enterprise.MCDefault mcDefaults = 7;
   */
  mcDefaults: MCDefault[];
};

/**
 * Describes the message Enterprise.MSPPermits.
 * Use `create(MSPPermitsSchema)` to create a new message.
 */
export const MSPPermitsSchema: GenMessage<MSPPermits> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 61);

/**
 * @generated from message Enterprise.License
 */
export type License = Message<"Enterprise.License"> & {
  /**
   * @generated from field: bool paid = 1;
   */
  paid: boolean;

  /**
   * @generated from field: int32 numberOfSeats = 2;
   */
  numberOfSeats: number;

  /**
   * @generated from field: int64 expiration = 3;
   */
  expiration: bigint;

  /**
   * @generated from field: int32 licenseKeyId = 4;
   */
  licenseKeyId: number;

  /**
   * @generated from field: int32 productTypeId = 5;
   */
  productTypeId: number;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: int64 enterpriseLicenseId = 7;
   */
  enterpriseLicenseId: bigint;

  /**
   * @generated from field: int32 seatsAllocated = 8;
   */
  seatsAllocated: number;

  /**
   * @generated from field: int32 seatsPending = 9;
   */
  seatsPending: number;

  /**
   * @generated from field: int32 tier = 10;
   */
  tier: number;

  /**
   * @generated from field: int32 filePlanTypeId = 11;
   */
  filePlanTypeId: number;

  /**
   * @generated from field: int64 maxBytes = 12;
   */
  maxBytes: bigint;

  /**
   * @generated from field: int64 storageExpiration = 13;
   */
  storageExpiration: bigint;

  /**
   * @generated from field: string licenseStatus = 14;
   */
  licenseStatus: string;

  /**
   * @generated from field: repeated Enterprise.MSPPool mspPool = 15;
   */
  mspPool: MSPPool[];

  /**
   * @generated from field: Enterprise.MSPContact managedBy = 16;
   */
  managedBy?: MSPContact;

  /**
   * @generated from field: repeated Enterprise.LicenseAddOn addOns = 17;
   */
  addOns: LicenseAddOn[];

  /**
   * @generated from field: int64 nextBillingDate = 18;
   */
  nextBillingDate: bigint;

  /**
   * @generated from field: bool hasMSPLegacyLog = 19;
   */
  hasMSPLegacyLog: boolean;

  /**
   * @generated from field: Enterprise.MSPPermits mspPermits = 20;
   */
  mspPermits?: MSPPermits;

  /**
   * @generated from field: bool distributor = 21;
   */
  distributor: boolean;
};

/**
 * Describes the message Enterprise.License.
 * Use `create(LicenseSchema)` to create a new message.
 */
export const LicenseSchema: GenMessage<License> = /*@__PURE__*/ messageDesc(file_enterprise, 62);

/**
 * @generated from message Enterprise.Bridge
 */
export type Bridge = Message<"Enterprise.Bridge"> & {
  /**
   * @generated from field: int64 bridgeId = 1;
   */
  bridgeId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string wanIpEnforcement = 3;
   */
  wanIpEnforcement: string;

  /**
   * @generated from field: string lanIpEnforcement = 4;
   */
  lanIpEnforcement: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;
};

/**
 * Describes the message Enterprise.Bridge.
 * Use `create(BridgeSchema)` to create a new message.
 */
export const BridgeSchema: GenMessage<Bridge> = /*@__PURE__*/ messageDesc(file_enterprise, 63);

/**
 * @generated from message Enterprise.Scim
 */
export type Scim = Message<"Enterprise.Scim"> & {
  /**
   * @generated from field: int64 scimId = 1;
   */
  scimId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 lastSynced = 4;
   */
  lastSynced: bigint;

  /**
   * @generated from field: string rolePrefix = 5;
   */
  rolePrefix: string;

  /**
   * @generated from field: bool uniqueGroups = 6;
   */
  uniqueGroups: boolean;
};

/**
 * Describes the message Enterprise.Scim.
 * Use `create(ScimSchema)` to create a new message.
 */
export const ScimSchema: GenMessage<Scim> = /*@__PURE__*/ messageDesc(file_enterprise, 64);

/**
 * @generated from message Enterprise.EmailProvision
 */
export type EmailProvision = Message<"Enterprise.EmailProvision"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: string method = 4;
   */
  method: string;
};

/**
 * Describes the message Enterprise.EmailProvision.
 * Use `create(EmailProvisionSchema)` to create a new message.
 */
export const EmailProvisionSchema: GenMessage<EmailProvision> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 65);

/**
 * @generated from message Enterprise.QueuedTeam
 */
export type QueuedTeam = Message<"Enterprise.QueuedTeam"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 nodeId = 3;
   */
  nodeId: bigint;

  /**
   * @generated from field: string encryptedData = 4;
   */
  encryptedData: string;
};

/**
 * Describes the message Enterprise.QueuedTeam.
 * Use `create(QueuedTeamSchema)` to create a new message.
 */
export const QueuedTeamSchema: GenMessage<QueuedTeam> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 66);

/**
 * @generated from message Enterprise.QueuedTeamUser
 */
export type QueuedTeamUser = Message<"Enterprise.QueuedTeamUser"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: repeated int64 users = 2;
   */
  users: bigint[];
};

/**
 * Describes the message Enterprise.QueuedTeamUser.
 * Use `create(QueuedTeamUserSchema)` to create a new message.
 */
export const QueuedTeamUserSchema: GenMessage<QueuedTeamUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 67);

/**
 * @generated from message Enterprise.TeamsAddResult
 */
export type TeamsAddResult = Message<"Enterprise.TeamsAddResult"> & {
  /**
   * @generated from field: repeated Enterprise.TeamAddResult successfulTeamAdd = 1;
   */
  successfulTeamAdd: TeamAddResult[];

  /**
   * @generated from field: repeated Enterprise.TeamAddResult unsuccessfulTeamAdd = 2;
   */
  unsuccessfulTeamAdd: TeamAddResult[];

  /**
   * @generated from field: string result = 3;
   */
  result: string;

  /**
   * @generated from field: string errorMessage = 4;
   */
  errorMessage: string;
};

/**
 * Describes the message Enterprise.TeamsAddResult.
 * Use `create(TeamsAddResultSchema)` to create a new message.
 */
export const TeamsAddResultSchema: GenMessage<TeamsAddResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 68);

/**
 * @generated from message Enterprise.TeamAddResult
 */
export type TeamAddResult = Message<"Enterprise.TeamAddResult"> & {
  /**
   * @generated from field: Enterprise.Team team = 1;
   */
  team?: Team;

  /**
   * @generated from field: string result = 2;
   */
  result: string;

  /**
   * @generated from field: string errorMessage = 3;
   */
  errorMessage: string;
};

/**
 * Describes the message Enterprise.TeamAddResult.
 * Use `create(TeamAddResultSchema)` to create a new message.
 */
export const TeamAddResultSchema: GenMessage<TeamAddResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 69);

/**
 * @generated from message Enterprise.SsoService
 */
export type SsoService = Message<"Enterprise.SsoService"> & {
  /**
   * @generated from field: int64 ssoServiceProviderId = 1;
   */
  ssoServiceProviderId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string sp_url = 4;
   */
  spUrl: string;

  /**
   * @generated from field: bool inviteNewUsers = 5;
   */
  inviteNewUsers: boolean;

  /**
   * @generated from field: bool active = 6;
   */
  active: boolean;

  /**
   * @generated from field: bool isCloud = 7;
   */
  isCloud: boolean;
};

/**
 * Describes the message Enterprise.SsoService.
 * Use `create(SsoServiceSchema)` to create a new message.
 */
export const SsoServiceSchema: GenMessage<SsoService> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 70);

/**
 * @generated from message Enterprise.ReportFilterUser
 */
export type ReportFilterUser = Message<"Enterprise.ReportFilterUser"> & {
  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message Enterprise.ReportFilterUser.
 * Use `create(ReportFilterUserSchema)` to create a new message.
 */
export const ReportFilterUserSchema: GenMessage<ReportFilterUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 71);

/**
 * @generated from message Enterprise.DeviceRequestForAdminApproval
 */
export type DeviceRequestForAdminApproval = Message<"Enterprise.DeviceRequestForAdminApproval"> & {
  /**
   * @generated from field: int64 deviceId = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: int64 enterpriseUserId = 2;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bytes encryptedDeviceToken = 3;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bytes devicePublicKey = 4;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: string deviceName = 5;
   */
  deviceName: string;

  /**
   * @generated from field: string clientVersion = 6;
   */
  clientVersion: string;

  /**
   * @generated from field: string deviceType = 7;
   */
  deviceType: string;

  /**
   * @generated from field: int64 date = 8;
   */
  date: bigint;

  /**
   * @generated from field: string ipAddress = 9;
   */
  ipAddress: string;

  /**
   * @generated from field: string location = 10;
   */
  location: string;

  /**
   * @generated from field: string email = 11;
   */
  email: string;

  /**
   * @generated from field: bytes accountUid = 12;
   */
  accountUid: Uint8Array;
};

/**
 * Describes the message Enterprise.DeviceRequestForAdminApproval.
 * Use `create(DeviceRequestForAdminApprovalSchema)` to create a new message.
 */
export const DeviceRequestForAdminApprovalSchema: GenMessage<DeviceRequestForAdminApproval> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 72);

/**
 * @generated from message Enterprise.EnterpriseData
 */
export type EnterpriseData = Message<"Enterprise.EnterpriseData"> & {
  /**
   * @generated from field: Enterprise.EnterpriseDataEntity entity = 1;
   */
  entity: EnterpriseDataEntity;

  /**
   * @generated from field: bool delete = 2;
   */
  delete: boolean;

  /**
   * @generated from field: repeated bytes data = 3;
   */
  data: Uint8Array[];
};

/**
 * Describes the message Enterprise.EnterpriseData.
 * Use `create(EnterpriseDataSchema)` to create a new message.
 */
export const EnterpriseDataSchema: GenMessage<EnterpriseData> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 73);

/**
 * @generated from message Enterprise.EnterpriseDataResponse
 */
export type EnterpriseDataResponse = Message<"Enterprise.EnterpriseDataResponse"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;

  /**
   * @generated from field: bool hasMore = 2;
   */
  hasMore: boolean;

  /**
   * @generated from field: Enterprise.CacheStatus cacheStatus = 3;
   */
  cacheStatus: CacheStatus;

  /**
   * @generated from field: repeated Enterprise.EnterpriseData data = 4;
   */
  data: EnterpriseData[];

  /**
   * @generated from field: Enterprise.GeneralDataEntity generalData = 5;
   */
  generalData?: GeneralDataEntity;
};

/**
 * Describes the message Enterprise.EnterpriseDataResponse.
 * Use `create(EnterpriseDataResponseSchema)` to create a new message.
 */
export const EnterpriseDataResponseSchema: GenMessage<EnterpriseDataResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 74);

/**
 * @generated from message Enterprise.BackupRequest
 */
export type BackupRequest = Message<"Enterprise.BackupRequest"> & {
  /**
   * @generated from field: bytes continuationToken = 1;
   */
  continuationToken: Uint8Array;
};

/**
 * Describes the message Enterprise.BackupRequest.
 * Use `create(BackupRequestSchema)` to create a new message.
 */
export const BackupRequestSchema: GenMessage<BackupRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 75);

/**
 * @generated from message Enterprise.BackupRecord
 */
export type BackupRecord = Message<"Enterprise.BackupRecord"> & {
  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes key = 3;
   */
  key: Uint8Array;

  /**
   * @generated from field: Enterprise.BackupKeyType keyType = 4;
   */
  keyType: BackupKeyType;

  /**
   * @generated from field: int32 version = 5;
   */
  version: number;

  /**
   * @generated from field: bytes data = 6;
   */
  data: Uint8Array;

  /**
   * @generated from field: bytes extra = 7;
   */
  extra: Uint8Array;
};

/**
 * Describes the message Enterprise.BackupRecord.
 * Use `create(BackupRecordSchema)` to create a new message.
 */
export const BackupRecordSchema: GenMessage<BackupRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 76);

/**
 * @generated from message Enterprise.BackupKey
 */
export type BackupKey = Message<"Enterprise.BackupKey"> & {
  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: bytes backupKey = 2;
   */
  backupKey: Uint8Array;
};

/**
 * Describes the message Enterprise.BackupKey.
 * Use `create(BackupKeySchema)` to create a new message.
 */
export const BackupKeySchema: GenMessage<BackupKey> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 77);

/**
 * @generated from message Enterprise.BackupUser
 */
export type BackupUser = Message<"Enterprise.BackupUser"> & {
  /**
   * @generated from field: int32 userId = 1;
   */
  userId: number;

  /**
   * @generated from field: string userName = 2;
   */
  userName: string;

  /**
   * @generated from field: bytes dataKey = 3;
   */
  dataKey: Uint8Array;

  /**
   * @generated from field: Enterprise.BackupUserDataKeyType dataKeyType = 4;
   */
  dataKeyType: BackupUserDataKeyType;

  /**
   * @generated from field: bytes privateKey = 5;
   */
  privateKey: Uint8Array;

  /**
   * @generated from field: bytes treeKey = 6;
   */
  treeKey: Uint8Array;

  /**
   * @generated from field: Enterprise.BackupKeyType treeKeyType = 7;
   */
  treeKeyType: BackupKeyType;

  /**
   * @generated from field: repeated Enterprise.BackupKey backupKeys = 8;
   */
  backupKeys: BackupKey[];

  /**
   * @generated from field: bytes privateECKey = 9;
   */
  privateECKey: Uint8Array;
};

/**
 * Describes the message Enterprise.BackupUser.
 * Use `create(BackupUserSchema)` to create a new message.
 */
export const BackupUserSchema: GenMessage<BackupUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 78);

/**
 * @generated from message Enterprise.BackupResponse
 */
export type BackupResponse = Message<"Enterprise.BackupResponse"> & {
  /**
   * @generated from field: bytes enterpriseEccPrivateKey = 1;
   */
  enterpriseEccPrivateKey: Uint8Array;

  /**
   * @generated from field: repeated Enterprise.BackupUser users = 2;
   */
  users: BackupUser[];

  /**
   * @generated from field: repeated Enterprise.BackupRecord records = 3;
   */
  records: BackupRecord[];

  /**
   * @generated from field: bytes continuationToken = 4;
   */
  continuationToken: Uint8Array;
};

/**
 * Describes the message Enterprise.BackupResponse.
 * Use `create(BackupResponseSchema)` to create a new message.
 */
export const BackupResponseSchema: GenMessage<BackupResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 79);

/**
 * @generated from message Enterprise.BackupFile
 */
export type BackupFile = Message<"Enterprise.BackupFile"> & {
  /**
   * @generated from field: string user = 1;
   */
  user: string;

  /**
   * @generated from field: bytes backupUid = 2;
   */
  backupUid: Uint8Array;

  /**
   * @generated from field: string fileName = 3;
   */
  fileName: string;

  /**
   * @generated from field: int64 created = 4;
   */
  created: bigint;

  /**
   * @generated from field: string downloadUrl = 5;
   */
  downloadUrl: string;
};

/**
 * Describes the message Enterprise.BackupFile.
 * Use `create(BackupFileSchema)` to create a new message.
 */
export const BackupFileSchema: GenMessage<BackupFile> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 80);

/**
 * @generated from message Enterprise.BackupsResponse
 */
export type BackupsResponse = Message<"Enterprise.BackupsResponse"> & {
  /**
   * @generated from field: repeated Enterprise.BackupFile files = 1;
   */
  files: BackupFile[];
};

/**
 * Describes the message Enterprise.BackupsResponse.
 * Use `create(BackupsResponseSchema)` to create a new message.
 */
export const BackupsResponseSchema: GenMessage<BackupsResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 81);

/**
 * @generated from message Enterprise.GetEnterpriseDataKeysRequest
 */
export type GetEnterpriseDataKeysRequest = Message<"Enterprise.GetEnterpriseDataKeysRequest"> & {
  /**
   * @generated from field: repeated int64 roleId = 1;
   */
  roleId: bigint[];
};

/**
 * Describes the message Enterprise.GetEnterpriseDataKeysRequest.
 * Use `create(GetEnterpriseDataKeysRequestSchema)` to create a new message.
 */
export const GetEnterpriseDataKeysRequestSchema: GenMessage<GetEnterpriseDataKeysRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 82);

/**
 * @generated from message Enterprise.GetEnterpriseDataKeysResponse
 */
export type GetEnterpriseDataKeysResponse = Message<"Enterprise.GetEnterpriseDataKeysResponse"> & {
  /**
   * @generated from field: repeated Enterprise.ReEncryptedRoleKey reEncryptedRoleKey = 1;
   */
  reEncryptedRoleKey: ReEncryptedRoleKey[];

  /**
   * @generated from field: repeated Enterprise.RoleKey roleKey = 2;
   */
  roleKey: RoleKey[];

  /**
   * @generated from field: Enterprise.MspKey mspKey = 3;
   */
  mspKey?: MspKey;

  /**
   * @generated from field: Enterprise.EnterpriseKeys enterpriseKeys = 4;
   */
  enterpriseKeys?: EnterpriseKeys;

  /**
   * @generated from field: Enterprise.TreeKey treeKey = 5;
   */
  treeKey?: TreeKey;
};

/**
 * Describes the message Enterprise.GetEnterpriseDataKeysResponse.
 * Use `create(GetEnterpriseDataKeysResponseSchema)` to create a new message.
 */
export const GetEnterpriseDataKeysResponseSchema: GenMessage<GetEnterpriseDataKeysResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 83);

/**
 * @generated from message Enterprise.RoleKey
 */
export type RoleKey = Message<"Enterprise.RoleKey"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: string encryptedKey = 2;
   */
  encryptedKey: string;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 3;
   */
  keyType: EncryptedKeyType;
};

/**
 * Describes the message Enterprise.RoleKey.
 * Use `create(RoleKeySchema)` to create a new message.
 */
export const RoleKeySchema: GenMessage<RoleKey> = /*@__PURE__*/ messageDesc(file_enterprise, 84);

/**
 * @generated from message Enterprise.MspKey
 */
export type MspKey = Message<"Enterprise.MspKey"> & {
  /**
   * @generated from field: string encryptedMspTreeKey = 1;
   */
  encryptedMspTreeKey: string;

  /**
   * @generated from field: Enterprise.EncryptedKeyType encryptedMspTreeKeyType = 2;
   */
  encryptedMspTreeKeyType: EncryptedKeyType;
};

/**
 * Describes the message Enterprise.MspKey.
 * Use `create(MspKeySchema)` to create a new message.
 */
export const MspKeySchema: GenMessage<MspKey> = /*@__PURE__*/ messageDesc(file_enterprise, 85);

/**
 * @generated from message Enterprise.EnterpriseKeys
 */
export type EnterpriseKeys = Message<"Enterprise.EnterpriseKeys"> & {
  /**
   * @generated from field: bytes rsaPublicKey = 1;
   */
  rsaPublicKey: Uint8Array;

  /**
   * @generated from field: bytes rsaEncryptedPrivateKey = 2;
   */
  rsaEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes eccPublicKey = 3;
   */
  eccPublicKey: Uint8Array;

  /**
   * @generated from field: bytes eccEncryptedPrivateKey = 4;
   */
  eccEncryptedPrivateKey: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterpriseKeys.
 * Use `create(EnterpriseKeysSchema)` to create a new message.
 */
export const EnterpriseKeysSchema: GenMessage<EnterpriseKeys> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 86);

/**
 * @generated from message Enterprise.TreeKey
 */
export type TreeKey = Message<"Enterprise.TreeKey"> & {
  /**
   * @generated from field: string treeKey = 1;
   */
  treeKey: string;

  /**
   * @generated from field: Enterprise.BackupKeyType keyTypeId = 2;
   */
  keyTypeId: BackupKeyType;
};

/**
 * Describes the message Enterprise.TreeKey.
 * Use `create(TreeKeySchema)` to create a new message.
 */
export const TreeKeySchema: GenMessage<TreeKey> = /*@__PURE__*/ messageDesc(file_enterprise, 87);

/**
 * @generated from message Enterprise.SharedRecordResponse
 */
export type SharedRecordResponse = Message<"Enterprise.SharedRecordResponse"> & {
  /**
   * @generated from field: repeated Enterprise.SharedRecordEvent events = 1;
   */
  events: SharedRecordEvent[];
};

/**
 * Describes the message Enterprise.SharedRecordResponse.
 * Use `create(SharedRecordResponseSchema)` to create a new message.
 */
export const SharedRecordResponseSchema: GenMessage<SharedRecordResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 88);

/**
 * @generated from message Enterprise.SharedRecordEvent
 */
export type SharedRecordEvent = Message<"Enterprise.SharedRecordEvent"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string userName = 2;
   */
  userName: string;

  /**
   * @generated from field: bool canEdit = 3;
   */
  canEdit: boolean;

  /**
   * @generated from field: bool canReshare = 4;
   */
  canReshare: boolean;

  /**
   * @generated from field: int32 shareFrom = 5;
   */
  shareFrom: number;
};

/**
 * Describes the message Enterprise.SharedRecordEvent.
 * Use `create(SharedRecordEventSchema)` to create a new message.
 */
export const SharedRecordEventSchema: GenMessage<SharedRecordEvent> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 89);

/**
 * @generated from message Enterprise.SetRestrictVisibilityRequest
 */
export type SetRestrictVisibilityRequest = Message<"Enterprise.SetRestrictVisibilityRequest"> & {
  /**
   * @generated from field: int64 nodeId = 1;
   */
  nodeId: bigint;
};

/**
 * Describes the message Enterprise.SetRestrictVisibilityRequest.
 * Use `create(SetRestrictVisibilityRequestSchema)` to create a new message.
 */
export const SetRestrictVisibilityRequestSchema: GenMessage<SetRestrictVisibilityRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 90);

/**
 * @generated from message Enterprise.UserAddRequest
 */
export type UserAddRequest = Message<"Enterprise.UserAddRequest"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: bytes encryptedData = 3;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 4;
   */
  keyType: EncryptedKeyType;

  /**
   * @generated from field: string fullName = 5;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 6;
   */
  jobTitle: string;

  /**
   * @generated from field: string email = 7;
   */
  email: string;

  /**
   * @generated from field: bool suppressEmailInvite = 8;
   */
  suppressEmailInvite: boolean;
};

/**
 * Describes the message Enterprise.UserAddRequest.
 * Use `create(UserAddRequestSchema)` to create a new message.
 */
export const UserAddRequestSchema: GenMessage<UserAddRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 91);

/**
 * @generated from message Enterprise.UserUpdateRequest
 */
export type UserUpdateRequest = Message<"Enterprise.UserUpdateRequest"> & {
  /**
   * @generated from field: repeated Enterprise.UserUpdate users = 1;
   */
  users: UserUpdate[];
};

/**
 * Describes the message Enterprise.UserUpdateRequest.
 * Use `create(UserUpdateRequestSchema)` to create a new message.
 */
export const UserUpdateRequestSchema: GenMessage<UserUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 92);

/**
 * @generated from message Enterprise.UserUpdate
 */
export type UserUpdate = Message<"Enterprise.UserUpdate"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: int64 nodeId = 2;
   */
  nodeId: bigint;

  /**
   * @generated from field: bytes encryptedData = 3;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 4;
   */
  keyType: EncryptedKeyType;

  /**
   * @generated from field: string fullName = 5;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 6;
   */
  jobTitle: string;

  /**
   * @generated from field: string email = 7;
   */
  email: string;
};

/**
 * Describes the message Enterprise.UserUpdate.
 * Use `create(UserUpdateSchema)` to create a new message.
 */
export const UserUpdateSchema: GenMessage<UserUpdate> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 93);

/**
 * @generated from message Enterprise.UserUpdateResponse
 */
export type UserUpdateResponse = Message<"Enterprise.UserUpdateResponse"> & {
  /**
   * @generated from field: repeated Enterprise.UserUpdateResult users = 1;
   */
  users: UserUpdateResult[];
};

/**
 * Describes the message Enterprise.UserUpdateResponse.
 * Use `create(UserUpdateResponseSchema)` to create a new message.
 */
export const UserUpdateResponseSchema: GenMessage<UserUpdateResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 94);

/**
 * @generated from message Enterprise.UserUpdateResult
 */
export type UserUpdateResult = Message<"Enterprise.UserUpdateResult"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: Enterprise.UserUpdateStatus status = 2;
   */
  status: UserUpdateStatus;
};

/**
 * Describes the message Enterprise.UserUpdateResult.
 * Use `create(UserUpdateResultSchema)` to create a new message.
 */
export const UserUpdateResultSchema: GenMessage<UserUpdateResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 95);

/**
 * @generated from message Enterprise.ComplianceRecordOwnersRequest
 */
export type ComplianceRecordOwnersRequest = Message<"Enterprise.ComplianceRecordOwnersRequest"> & {
  /**
   * @generated from field: repeated int64 nodeIds = 1;
   */
  nodeIds: bigint[];

  /**
   * @generated from field: bool includeNonShared = 2;
   */
  includeNonShared: boolean;
};

/**
 * Describes the message Enterprise.ComplianceRecordOwnersRequest.
 * Use `create(ComplianceRecordOwnersRequestSchema)` to create a new message.
 */
export const ComplianceRecordOwnersRequestSchema: GenMessage<ComplianceRecordOwnersRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 96);

/**
 * @generated from message Enterprise.ComplianceRecordOwnersResponse
 */
export type ComplianceRecordOwnersResponse =
  Message<"Enterprise.ComplianceRecordOwnersResponse"> & {
    /**
     * @generated from field: repeated Enterprise.RecordOwner recordOwners = 1;
     */
    recordOwners: RecordOwner[];
  };

/**
 * Describes the message Enterprise.ComplianceRecordOwnersResponse.
 * Use `create(ComplianceRecordOwnersResponseSchema)` to create a new message.
 */
export const ComplianceRecordOwnersResponseSchema: GenMessage<ComplianceRecordOwnersResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 97);

/**
 * @generated from message Enterprise.RecordOwner
 */
export type RecordOwner = Message<"Enterprise.RecordOwner"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bool shared = 2;
   */
  shared: boolean;
};

/**
 * Describes the message Enterprise.RecordOwner.
 * Use `create(RecordOwnerSchema)` to create a new message.
 */
export const RecordOwnerSchema: GenMessage<RecordOwner> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 98);

/**
 * @generated from message Enterprise.PreliminaryComplianceDataRequest
 */
export type PreliminaryComplianceDataRequest =
  Message<"Enterprise.PreliminaryComplianceDataRequest"> & {
    /**
     * @generated from field: repeated int64 enterpriseUserIds = 1;
     */
    enterpriseUserIds: bigint[];

    /**
     * @generated from field: bool includeNonShared = 2;
     */
    includeNonShared: boolean;

    /**
     * @generated from field: bytes continuationToken = 3;
     */
    continuationToken: Uint8Array;

    /**
     * @generated from field: bool includeTotalMatchingRecordsInFirstResponse = 4;
     */
    includeTotalMatchingRecordsInFirstResponse: boolean;
  };

/**
 * Describes the message Enterprise.PreliminaryComplianceDataRequest.
 * Use `create(PreliminaryComplianceDataRequestSchema)` to create a new message.
 */
export const PreliminaryComplianceDataRequestSchema: GenMessage<PreliminaryComplianceDataRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 99);

/**
 * @generated from message Enterprise.PreliminaryComplianceDataResponse
 */
export type PreliminaryComplianceDataResponse =
  Message<"Enterprise.PreliminaryComplianceDataResponse"> & {
    /**
     * @generated from field: repeated Enterprise.AuditUserData auditUserData = 1;
     */
    auditUserData: AuditUserData[];

    /**
     * @generated from field: bytes continuationToken = 2;
     */
    continuationToken: Uint8Array;

    /**
     * @generated from field: bool hasMore = 3;
     */
    hasMore: boolean;

    /**
     * @generated from field: int32 totalMatchingRecords = 4;
     */
    totalMatchingRecords: number;
  };

/**
 * Describes the message Enterprise.PreliminaryComplianceDataResponse.
 * Use `create(PreliminaryComplianceDataResponseSchema)` to create a new message.
 */
export const PreliminaryComplianceDataResponseSchema: GenMessage<PreliminaryComplianceDataResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 100);

/**
 * @generated from message Enterprise.AuditUserRecord
 */
export type AuditUserRecord = Message<"Enterprise.AuditUserRecord"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedData = 2;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: bool shared = 3;
   */
  shared: boolean;
};

/**
 * Describes the message Enterprise.AuditUserRecord.
 * Use `create(AuditUserRecordSchema)` to create a new message.
 */
export const AuditUserRecordSchema: GenMessage<AuditUserRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 101);

/**
 * @generated from message Enterprise.AuditUserData
 */
export type AuditUserData = Message<"Enterprise.AuditUserData"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: repeated Enterprise.AuditUserRecord auditUserRecords = 2;
   */
  auditUserRecords: AuditUserRecord[];

  /**
   * @generated from field: Enterprise.AuditUserStatus status = 3;
   */
  status: AuditUserStatus;
};

/**
 * Describes the message Enterprise.AuditUserData.
 * Use `create(AuditUserDataSchema)` to create a new message.
 */
export const AuditUserDataSchema: GenMessage<AuditUserData> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 102);

/**
 * @generated from message Enterprise.ComplianceReportFilters
 */
export type ComplianceReportFilters = Message<"Enterprise.ComplianceReportFilters"> & {
  /**
   * @generated from field: repeated string recordTitles = 1;
   */
  recordTitles: string[];

  /**
   * @generated from field: repeated bytes recordUids = 2;
   */
  recordUids: Uint8Array[];

  /**
   * @generated from field: repeated int64 jobTitles = 3;
   */
  jobTitles: bigint[];

  /**
   * @generated from field: repeated string urls = 4;
   */
  urls: string[];

  /**
   * @generated from field: repeated int64 enterpriseUserIds = 5;
   */
  enterpriseUserIds: bigint[];
};

/**
 * Describes the message Enterprise.ComplianceReportFilters.
 * Use `create(ComplianceReportFiltersSchema)` to create a new message.
 */
export const ComplianceReportFiltersSchema: GenMessage<ComplianceReportFilters> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 103);

/**
 * @generated from message Enterprise.ComplianceReportRequest
 */
export type ComplianceReportRequest = Message<"Enterprise.ComplianceReportRequest"> & {
  /**
   * @generated from field: Enterprise.ComplianceReportRun complianceReportRun = 1;
   */
  complianceReportRun?: ComplianceReportRun;

  /**
   * @generated from field: string reportName = 2;
   */
  reportName: string;

  /**
   * @generated from field: bool saveReport = 3;
   */
  saveReport: boolean;
};

/**
 * Describes the message Enterprise.ComplianceReportRequest.
 * Use `create(ComplianceReportRequestSchema)` to create a new message.
 */
export const ComplianceReportRequestSchema: GenMessage<ComplianceReportRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 104);

/**
 * @generated from message Enterprise.ComplianceReportRun
 */
export type ComplianceReportRun = Message<"Enterprise.ComplianceReportRun"> & {
  /**
   * @generated from field: Enterprise.ComplianceReportCriteriaAndFilter reportCriteriaAndFilter = 1;
   */
  reportCriteriaAndFilter?: ComplianceReportCriteriaAndFilter;

  /**
   * @generated from field: repeated int64 users = 2;
   */
  users: bigint[];

  /**
   * @generated from field: repeated bytes records = 3;
   */
  records: Uint8Array[];
};

/**
 * Describes the message Enterprise.ComplianceReportRun.
 * Use `create(ComplianceReportRunSchema)` to create a new message.
 */
export const ComplianceReportRunSchema: GenMessage<ComplianceReportRun> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 105);

/**
 * @generated from message Enterprise.ComplianceReportCriteriaAndFilter
 */
export type ComplianceReportCriteriaAndFilter =
  Message<"Enterprise.ComplianceReportCriteriaAndFilter"> & {
    /**
     * @generated from field: int64 nodeId = 1;
     */
    nodeId: bigint;

    /**
     * @generated from field: bytes criteriaUid = 2;
     */
    criteriaUid: Uint8Array;

    /**
     * @generated from field: string criteriaName = 3;
     */
    criteriaName: string;

    /**
     * @generated from field: Enterprise.ComplianceReportCriteria criteria = 4;
     */
    criteria?: ComplianceReportCriteria;

    /**
     * @generated from field: repeated Enterprise.ComplianceReportFilter filters = 5;
     */
    filters: ComplianceReportFilter[];

    /**
     * @generated from field: int64 lastModified = 6;
     */
    lastModified: bigint;

    /**
     * @generated from field: bytes nodeEncryptedData = 7;
     */
    nodeEncryptedData: Uint8Array;
  };

/**
 * Describes the message Enterprise.ComplianceReportCriteriaAndFilter.
 * Use `create(ComplianceReportCriteriaAndFilterSchema)` to create a new message.
 */
export const ComplianceReportCriteriaAndFilterSchema: GenMessage<ComplianceReportCriteriaAndFilter> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 106);

/**
 * @generated from message Enterprise.ComplianceReportCriteria
 */
export type ComplianceReportCriteria = Message<"Enterprise.ComplianceReportCriteria"> & {
  /**
   * @generated from field: repeated string jobTitles = 1;
   */
  jobTitles: string[];

  /**
   * @generated from field: repeated int64 enterpriseUserIds = 2;
   */
  enterpriseUserIds: bigint[];

  /**
   * @generated from field: bool includeNonShared = 3;
   */
  includeNonShared: boolean;
};

/**
 * Describes the message Enterprise.ComplianceReportCriteria.
 * Use `create(ComplianceReportCriteriaSchema)` to create a new message.
 */
export const ComplianceReportCriteriaSchema: GenMessage<ComplianceReportCriteria> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 107);

/**
 * @generated from message Enterprise.ComplianceReportFilter
 */
export type ComplianceReportFilter = Message<"Enterprise.ComplianceReportFilter"> & {
  /**
   * @generated from field: repeated string recordTitles = 1;
   */
  recordTitles: string[];

  /**
   * @generated from field: repeated bytes recordUids = 2;
   */
  recordUids: Uint8Array[];

  /**
   * @generated from field: repeated string jobTitles = 3;
   */
  jobTitles: string[];

  /**
   * @generated from field: repeated string urls = 4;
   */
  urls: string[];

  /**
   * @generated from field: repeated string recordTypes = 5;
   */
  recordTypes: string[];
};

/**
 * Describes the message Enterprise.ComplianceReportFilter.
 * Use `create(ComplianceReportFilterSchema)` to create a new message.
 */
export const ComplianceReportFilterSchema: GenMessage<ComplianceReportFilter> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 108);

/**
 * @generated from message Enterprise.ComplianceReportResponse
 */
export type ComplianceReportResponse = Message<"Enterprise.ComplianceReportResponse"> & {
  /**
   * @generated from field: int64 dateGenerated = 1;
   */
  dateGenerated: bigint;

  /**
   * @generated from field: string runByUserName = 2;
   */
  runByUserName: string;

  /**
   * @generated from field: string reportName = 3;
   */
  reportName: string;

  /**
   * @generated from field: bytes reportUid = 4;
   */
  reportUid: Uint8Array;

  /**
   * @generated from field: Enterprise.ComplianceReportRun complianceReportRun = 5;
   */
  complianceReportRun?: ComplianceReportRun;

  /**
   * @generated from field: repeated Enterprise.UserProfile userProfiles = 6;
   */
  userProfiles: UserProfile[];

  /**
   * @generated from field: repeated Enterprise.AuditTeam auditTeams = 7;
   */
  auditTeams: AuditTeam[];

  /**
   * @generated from field: repeated Enterprise.AuditRecord auditRecords = 8;
   */
  auditRecords: AuditRecord[];

  /**
   * @generated from field: repeated Enterprise.UserRecord userRecords = 9;
   */
  userRecords: UserRecord[];

  /**
   * @generated from field: repeated Enterprise.SharedFolderRecord sharedFolderRecords = 10;
   */
  sharedFolderRecords: SharedFolderRecord[];

  /**
   * @generated from field: repeated Enterprise.SharedFolderUser sharedFolderUsers = 11;
   */
  sharedFolderUsers: SharedFolderUser[];

  /**
   * @generated from field: repeated Enterprise.SharedFolderTeam sharedFolderTeams = 12;
   */
  sharedFolderTeams: SharedFolderTeam[];

  /**
   * @generated from field: repeated Enterprise.AuditTeamUser auditTeamUsers = 13;
   */
  auditTeamUsers: AuditTeamUser[];

  /**
   * @generated from field: repeated Enterprise.AuditRole auditRoles = 14;
   */
  auditRoles: AuditRole[];

  /**
   * @generated from field: repeated Enterprise.LinkedRecord linkedRecords = 15;
   */
  linkedRecords: LinkedRecord[];
};

/**
 * Describes the message Enterprise.ComplianceReportResponse.
 * Use `create(ComplianceReportResponseSchema)` to create a new message.
 */
export const ComplianceReportResponseSchema: GenMessage<ComplianceReportResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 109);

/**
 * @generated from message Enterprise.AuditRecord
 */
export type AuditRecord = Message<"Enterprise.AuditRecord"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes auditData = 2;
   */
  auditData: Uint8Array;

  /**
   * @generated from field: bool hasAttachments = 3;
   */
  hasAttachments: boolean;

  /**
   * @generated from field: bool inTrash = 4;
   */
  inTrash: boolean;

  /**
   * @generated from field: int32 treeLeft = 5;
   */
  treeLeft: number;

  /**
   * @generated from field: int32 treeRight = 6;
   */
  treeRight: number;
};

/**
 * Describes the message Enterprise.AuditRecord.
 * Use `create(AuditRecordSchema)` to create a new message.
 */
export const AuditRecordSchema: GenMessage<AuditRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 110);

/**
 * @generated from message Enterprise.AuditRole
 */
export type AuditRole = Message<"Enterprise.AuditRole"> & {
  /**
   * @generated from field: int64 roleId = 1;
   */
  roleId: bigint;

  /**
   * @generated from field: bytes encryptedData = 2;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: bool restrictShareOutsideEnterprise = 3;
   */
  restrictShareOutsideEnterprise: boolean;

  /**
   * @generated from field: bool restrictShareAll = 4;
   */
  restrictShareAll: boolean;

  /**
   * @generated from field: bool restrictShareOfAttachments = 5;
   */
  restrictShareOfAttachments: boolean;

  /**
   * @generated from field: bool restrictMaskPasswordsWhileEditing = 6;
   */
  restrictMaskPasswordsWhileEditing: boolean;

  /**
   * @generated from field: repeated Enterprise.RoleNodeManagement roleNodeManagements = 7;
   */
  roleNodeManagements: RoleNodeManagement[];
};

/**
 * Describes the message Enterprise.AuditRole.
 * Use `create(AuditRoleSchema)` to create a new message.
 */
export const AuditRoleSchema: GenMessage<AuditRole> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 111);

/**
 * @generated from message Enterprise.RoleNodeManagement
 */
export type RoleNodeManagement = Message<"Enterprise.RoleNodeManagement"> & {
  /**
   * @generated from field: int32 treeLeft = 1;
   */
  treeLeft: number;

  /**
   * @generated from field: int32 treeRight = 2;
   */
  treeRight: number;

  /**
   * @generated from field: bool cascade = 3;
   */
  cascade: boolean;

  /**
   * @generated from field: int32 privileges = 4;
   */
  privileges: number;
};

/**
 * Describes the message Enterprise.RoleNodeManagement.
 * Use `create(RoleNodeManagementSchema)` to create a new message.
 */
export const RoleNodeManagementSchema: GenMessage<RoleNodeManagement> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 112);

/**
 * @generated from message Enterprise.UserProfile
 */
export type UserProfile = Message<"Enterprise.UserProfile"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string fullName = 2;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 3;
   */
  jobTitle: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: repeated int64 roleIds = 5;
   */
  roleIds: bigint[];
};

/**
 * Describes the message Enterprise.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 113);

/**
 * @generated from message Enterprise.RecordPermission
 */
export type RecordPermission = Message<"Enterprise.RecordPermission"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: int32 permissionBits = 2;
   */
  permissionBits: number;
};

/**
 * Describes the message Enterprise.RecordPermission.
 * Use `create(RecordPermissionSchema)` to create a new message.
 */
export const RecordPermissionSchema: GenMessage<RecordPermission> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 114);

/**
 * @generated from message Enterprise.UserRecord
 */
export type UserRecord = Message<"Enterprise.UserRecord"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: repeated Enterprise.RecordPermission recordPermissions = 2;
   */
  recordPermissions: RecordPermission[];
};

/**
 * Describes the message Enterprise.UserRecord.
 * Use `create(UserRecordSchema)` to create a new message.
 */
export const UserRecordSchema: GenMessage<UserRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 115);

/**
 * @generated from message Enterprise.AuditTeam
 */
export type AuditTeam = Message<"Enterprise.AuditTeam"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: string teamName = 2;
   */
  teamName: string;

  /**
   * @generated from field: bool restrictEdit = 3;
   */
  restrictEdit: boolean;

  /**
   * @generated from field: bool restrictShare = 4;
   */
  restrictShare: boolean;
};

/**
 * Describes the message Enterprise.AuditTeam.
 * Use `create(AuditTeamSchema)` to create a new message.
 */
export const AuditTeamSchema: GenMessage<AuditTeam> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 116);

/**
 * @generated from message Enterprise.AuditTeamUser
 */
export type AuditTeamUser = Message<"Enterprise.AuditTeamUser"> & {
  /**
   * @generated from field: bytes teamUid = 1;
   */
  teamUid: Uint8Array;

  /**
   * @generated from field: repeated int64 enterpriseUserIds = 2;
   */
  enterpriseUserIds: bigint[];
};

/**
 * Describes the message Enterprise.AuditTeamUser.
 * Use `create(AuditTeamUserSchema)` to create a new message.
 */
export const AuditTeamUserSchema: GenMessage<AuditTeamUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 117);

/**
 * @generated from message Enterprise.SharedFolderRecord
 */
export type SharedFolderRecord = Message<"Enterprise.SharedFolderRecord"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: repeated Enterprise.RecordPermission recordPermissions = 2;
   */
  recordPermissions: RecordPermission[];

  /**
   * @generated from field: repeated Enterprise.ShareAdminRecord shareAdminRecords = 3;
   */
  shareAdminRecords: ShareAdminRecord[];
};

/**
 * Describes the message Enterprise.SharedFolderRecord.
 * Use `create(SharedFolderRecordSchema)` to create a new message.
 */
export const SharedFolderRecordSchema: GenMessage<SharedFolderRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 118);

/**
 * @generated from message Enterprise.ShareAdminRecord
 */
export type ShareAdminRecord = Message<"Enterprise.ShareAdminRecord"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: repeated int32 recordPermissionIndexes = 2;
   */
  recordPermissionIndexes: number[];
};

/**
 * Describes the message Enterprise.ShareAdminRecord.
 * Use `create(ShareAdminRecordSchema)` to create a new message.
 */
export const ShareAdminRecordSchema: GenMessage<ShareAdminRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 119);

/**
 * @generated from message Enterprise.SharedFolderUser
 */
export type SharedFolderUser = Message<"Enterprise.SharedFolderUser"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: repeated int64 enterpriseUserIds = 2;
   */
  enterpriseUserIds: bigint[];
};

/**
 * Describes the message Enterprise.SharedFolderUser.
 * Use `create(SharedFolderUserSchema)` to create a new message.
 */
export const SharedFolderUserSchema: GenMessage<SharedFolderUser> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 120);

/**
 * @generated from message Enterprise.SharedFolderTeam
 */
export type SharedFolderTeam = Message<"Enterprise.SharedFolderTeam"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: repeated bytes teamUids = 2;
   */
  teamUids: Uint8Array[];
};

/**
 * Describes the message Enterprise.SharedFolderTeam.
 * Use `create(SharedFolderTeamSchema)` to create a new message.
 */
export const SharedFolderTeamSchema: GenMessage<SharedFolderTeam> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 121);

/**
 * @generated from message Enterprise.GetComplianceReportRequest
 */
export type GetComplianceReportRequest = Message<"Enterprise.GetComplianceReportRequest"> & {
  /**
   * @generated from field: bytes reportUid = 1;
   */
  reportUid: Uint8Array;
};

/**
 * Describes the message Enterprise.GetComplianceReportRequest.
 * Use `create(GetComplianceReportRequestSchema)` to create a new message.
 */
export const GetComplianceReportRequestSchema: GenMessage<GetComplianceReportRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 122);

/**
 * @generated from message Enterprise.GetComplianceReportResponse
 */
export type GetComplianceReportResponse = Message<"Enterprise.GetComplianceReportResponse"> & {
  /**
   * @generated from field: string downloadUrl = 1;
   */
  downloadUrl: string;
};

/**
 * Describes the message Enterprise.GetComplianceReportResponse.
 * Use `create(GetComplianceReportResponseSchema)` to create a new message.
 */
export const GetComplianceReportResponseSchema: GenMessage<GetComplianceReportResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 123);

/**
 * @generated from message Enterprise.ComplianceReportCriteriaRequest
 */
export type ComplianceReportCriteriaRequest =
  Message<"Enterprise.ComplianceReportCriteriaRequest"> & {
    /**
     * @generated from field: bytes criteriaUid = 1;
     */
    criteriaUid: Uint8Array;
  };

/**
 * Describes the message Enterprise.ComplianceReportCriteriaRequest.
 * Use `create(ComplianceReportCriteriaRequestSchema)` to create a new message.
 */
export const ComplianceReportCriteriaRequestSchema: GenMessage<ComplianceReportCriteriaRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 124);

/**
 * @generated from message Enterprise.SaveComplianceReportCriteriaResponse
 */
export type SaveComplianceReportCriteriaResponse =
  Message<"Enterprise.SaveComplianceReportCriteriaResponse"> & {
    /**
     * @generated from field: bytes criteriaUid = 1;
     */
    criteriaUid: Uint8Array;
  };

/**
 * Describes the message Enterprise.SaveComplianceReportCriteriaResponse.
 * Use `create(SaveComplianceReportCriteriaResponseSchema)` to create a new message.
 */
export const SaveComplianceReportCriteriaResponseSchema: GenMessage<SaveComplianceReportCriteriaResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 125);

/**
 * @generated from message Enterprise.LinkedRecord
 */
export type LinkedRecord = Message<"Enterprise.LinkedRecord"> & {
  /**
   * @generated from field: bytes ownerUid = 1;
   */
  ownerUid: Uint8Array;

  /**
   * @generated from field: repeated bytes recordUids = 2;
   */
  recordUids: Uint8Array[];
};

/**
 * Describes the message Enterprise.LinkedRecord.
 * Use `create(LinkedRecordSchema)` to create a new message.
 */
export const LinkedRecordSchema: GenMessage<LinkedRecord> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 126);

/**
 * @generated from message Enterprise.GetSharingAdminsRequest
 */
export type GetSharingAdminsRequest = Message<"Enterprise.GetSharingAdminsRequest"> & {
  /**
   * @generated from field: bytes sharedFolderUid = 1;
   */
  sharedFolderUid: Uint8Array;

  /**
   * @generated from field: bytes recordUid = 2;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string username = 3;
   */
  username: string;
};

/**
 * Describes the message Enterprise.GetSharingAdminsRequest.
 * Use `create(GetSharingAdminsRequestSchema)` to create a new message.
 */
export const GetSharingAdminsRequestSchema: GenMessage<GetSharingAdminsRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 127);

/**
 * @generated from message Enterprise.UserProfileExt
 */
export type UserProfileExt = Message<"Enterprise.UserProfileExt"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string fullName = 2;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 3;
   */
  jobTitle: string;

  /**
   * @generated from field: bool isMSPMCAdmin = 4;
   */
  isMSPMCAdmin: boolean;

  /**
   * @generated from field: bool isInSharedFolder = 5;
   */
  isInSharedFolder: boolean;

  /**
   * @generated from field: bool isShareAdminForRequestedObject = 6;
   */
  isShareAdminForRequestedObject: boolean;

  /**
   * @generated from field: bool isShareAdminForSharedFolderOwner = 7;
   */
  isShareAdminForSharedFolderOwner: boolean;

  /**
   * @generated from field: bool hasAccessToObject = 8;
   */
  hasAccessToObject: boolean;
};

/**
 * Describes the message Enterprise.UserProfileExt.
 * Use `create(UserProfileExtSchema)` to create a new message.
 */
export const UserProfileExtSchema: GenMessage<UserProfileExt> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 128);

/**
 * @generated from message Enterprise.GetSharingAdminsResponse
 */
export type GetSharingAdminsResponse = Message<"Enterprise.GetSharingAdminsResponse"> & {
  /**
   * @generated from field: repeated Enterprise.UserProfileExt userProfileExts = 1;
   */
  userProfileExts: UserProfileExt[];
};

/**
 * Describes the message Enterprise.GetSharingAdminsResponse.
 * Use `create(GetSharingAdminsResponseSchema)` to create a new message.
 */
export const GetSharingAdminsResponseSchema: GenMessage<GetSharingAdminsResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 129);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddRequest
 */
export type TeamsEnterpriseUsersAddRequest =
  Message<"Enterprise.TeamsEnterpriseUsersAddRequest"> & {
    /**
     * @generated from field: repeated Enterprise.TeamsEnterpriseUsersAddTeamRequest teams = 1;
     */
    teams: TeamsEnterpriseUsersAddTeamRequest[];
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddRequest.
 * Use `create(TeamsEnterpriseUsersAddRequestSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddRequestSchema: GenMessage<TeamsEnterpriseUsersAddRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 130);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddTeamRequest
 */
export type TeamsEnterpriseUsersAddTeamRequest =
  Message<"Enterprise.TeamsEnterpriseUsersAddTeamRequest"> & {
    /**
     * @generated from field: bytes teamUid = 1;
     */
    teamUid: Uint8Array;

    /**
     * @generated from field: repeated Enterprise.TeamsEnterpriseUsersAddUserRequest users = 2;
     */
    users: TeamsEnterpriseUsersAddUserRequest[];
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddTeamRequest.
 * Use `create(TeamsEnterpriseUsersAddTeamRequestSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddTeamRequestSchema: GenMessage<TeamsEnterpriseUsersAddTeamRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 131);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddUserRequest
 */
export type TeamsEnterpriseUsersAddUserRequest =
  Message<"Enterprise.TeamsEnterpriseUsersAddUserRequest"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: Enterprise.TeamUserType userType = 2;
     */
    userType: TeamUserType;

    /**
     * @generated from field: string teamKey = 3;
     */
    teamKey: string;

    /**
     * @generated from field: Enterprise.TypedKey typedTeamKey = 4;
     */
    typedTeamKey?: TypedKey;
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddUserRequest.
 * Use `create(TeamsEnterpriseUsersAddUserRequestSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddUserRequestSchema: GenMessage<TeamsEnterpriseUsersAddUserRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 132);

/**
 * @generated from message Enterprise.TypedKey
 */
export type TypedKey = Message<"Enterprise.TypedKey"> & {
  /**
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 2;
   */
  keyType: EncryptedKeyType;
};

/**
 * Describes the message Enterprise.TypedKey.
 * Use `create(TypedKeySchema)` to create a new message.
 */
export const TypedKeySchema: GenMessage<TypedKey> = /*@__PURE__*/ messageDesc(file_enterprise, 133);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddResponse
 */
export type TeamsEnterpriseUsersAddResponse =
  Message<"Enterprise.TeamsEnterpriseUsersAddResponse"> & {
    /**
     * @generated from field: repeated Enterprise.TeamsEnterpriseUsersAddTeamResponse teams = 1;
     */
    teams: TeamsEnterpriseUsersAddTeamResponse[];

    /**
     * @generated from field: int64 revision = 2;
     */
    revision: bigint;
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddResponse.
 * Use `create(TeamsEnterpriseUsersAddResponseSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddResponseSchema: GenMessage<TeamsEnterpriseUsersAddResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 134);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddTeamResponse
 */
export type TeamsEnterpriseUsersAddTeamResponse =
  Message<"Enterprise.TeamsEnterpriseUsersAddTeamResponse"> & {
    /**
     * @generated from field: bytes teamUid = 1;
     */
    teamUid: Uint8Array;

    /**
     * @generated from field: repeated Enterprise.TeamsEnterpriseUsersAddUserResponse users = 2;
     */
    users: TeamsEnterpriseUsersAddUserResponse[];

    /**
     * @generated from field: bool success = 3;
     */
    success: boolean;

    /**
     * @generated from field: string message = 4;
     */
    message: string;

    /**
     * @generated from field: string resultCode = 5;
     */
    resultCode: string;

    /**
     * @generated from field: string additionalInfo = 6;
     */
    additionalInfo: string;
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddTeamResponse.
 * Use `create(TeamsEnterpriseUsersAddTeamResponseSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddTeamResponseSchema: GenMessage<TeamsEnterpriseUsersAddTeamResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 135);

/**
 * @generated from message Enterprise.TeamsEnterpriseUsersAddUserResponse
 */
export type TeamsEnterpriseUsersAddUserResponse =
  Message<"Enterprise.TeamsEnterpriseUsersAddUserResponse"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: int64 revision = 2;
     */
    revision: bigint;

    /**
     * @generated from field: bool success = 3;
     */
    success: boolean;

    /**
     * @generated from field: string message = 4;
     */
    message: string;

    /**
     * @generated from field: string resultCode = 5;
     */
    resultCode: string;

    /**
     * @generated from field: string additionalInfo = 6;
     */
    additionalInfo: string;
  };

/**
 * Describes the message Enterprise.TeamsEnterpriseUsersAddUserResponse.
 * Use `create(TeamsEnterpriseUsersAddUserResponseSchema)` to create a new message.
 */
export const TeamsEnterpriseUsersAddUserResponseSchema: GenMessage<TeamsEnterpriseUsersAddUserResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 136);

/**
 * @generated from message Enterprise.DomainAlias
 */
export type DomainAlias = Message<"Enterprise.DomainAlias"> & {
  /**
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * @generated from field: string alias = 2;
   */
  alias: string;

  /**
   * @generated from field: int32 status = 3;
   */
  status: number;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message Enterprise.DomainAlias.
 * Use `create(DomainAliasSchema)` to create a new message.
 */
export const DomainAliasSchema: GenMessage<DomainAlias> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 137);

/**
 * @generated from message Enterprise.DomainAliasRequest
 */
export type DomainAliasRequest = Message<"Enterprise.DomainAliasRequest"> & {
  /**
   * @generated from field: repeated Enterprise.DomainAlias domainAlias = 1;
   */
  domainAlias: DomainAlias[];
};

/**
 * Describes the message Enterprise.DomainAliasRequest.
 * Use `create(DomainAliasRequestSchema)` to create a new message.
 */
export const DomainAliasRequestSchema: GenMessage<DomainAliasRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 138);

/**
 * @generated from message Enterprise.DomainAliasResponse
 */
export type DomainAliasResponse = Message<"Enterprise.DomainAliasResponse"> & {
  /**
   * @generated from field: repeated Enterprise.DomainAlias domainAlias = 1;
   */
  domainAlias: DomainAlias[];
};

/**
 * Describes the message Enterprise.DomainAliasResponse.
 * Use `create(DomainAliasResponseSchema)` to create a new message.
 */
export const DomainAliasResponseSchema: GenMessage<DomainAliasResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 139);

/**
 * @generated from message Enterprise.EnterpriseUsersProvisionRequest
 */
export type EnterpriseUsersProvisionRequest =
  Message<"Enterprise.EnterpriseUsersProvisionRequest"> & {
    /**
     * @generated from field: repeated Enterprise.EnterpriseUsersProvision users = 1;
     */
    users: EnterpriseUsersProvision[];

    /**
     * @generated from field: string clientVersion = 2;
     */
    clientVersion: string;
  };

/**
 * Describes the message Enterprise.EnterpriseUsersProvisionRequest.
 * Use `create(EnterpriseUsersProvisionRequestSchema)` to create a new message.
 */
export const EnterpriseUsersProvisionRequestSchema: GenMessage<EnterpriseUsersProvisionRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 140);

/**
 * @generated from message Enterprise.EnterpriseUsersProvision
 */
export type EnterpriseUsersProvision = Message<"Enterprise.EnterpriseUsersProvision"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: int64 nodeId = 3;
   */
  nodeId: bigint;

  /**
   * @generated from field: string encryptedData = 4;
   */
  encryptedData: string;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 5;
   */
  keyType: EncryptedKeyType;

  /**
   * @generated from field: string fullName = 6;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 7;
   */
  jobTitle: string;

  /**
   * @generated from field: bytes enterpriseUsersDataKey = 8;
   */
  enterpriseUsersDataKey: Uint8Array;

  /**
   * @generated from field: bytes authVerifier = 9;
   */
  authVerifier: Uint8Array;

  /**
   * @generated from field: bytes encryptionParams = 10;
   */
  encryptionParams: Uint8Array;

  /**
   * @generated from field: bytes rsaPublicKey = 11;
   */
  rsaPublicKey: Uint8Array;

  /**
   * @generated from field: bytes rsaEncryptedPrivateKey = 12;
   */
  rsaEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes eccPublicKey = 13;
   */
  eccPublicKey: Uint8Array;

  /**
   * @generated from field: bytes eccEncryptedPrivateKey = 14;
   */
  eccEncryptedPrivateKey: Uint8Array;

  /**
   * @generated from field: bytes encryptedDeviceToken = 15;
   */
  encryptedDeviceToken: Uint8Array;

  /**
   * @generated from field: bytes encryptedClientKey = 16;
   */
  encryptedClientKey: Uint8Array;
};

/**
 * Describes the message Enterprise.EnterpriseUsersProvision.
 * Use `create(EnterpriseUsersProvisionSchema)` to create a new message.
 */
export const EnterpriseUsersProvisionSchema: GenMessage<EnterpriseUsersProvision> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 141);

/**
 * @generated from message Enterprise.EnterpriseUsersProvisionResponse
 */
export type EnterpriseUsersProvisionResponse =
  Message<"Enterprise.EnterpriseUsersProvisionResponse"> & {
    /**
     * @generated from field: repeated Enterprise.EnterpriseUsersProvisionResult results = 1;
     */
    results: EnterpriseUsersProvisionResult[];
  };

/**
 * Describes the message Enterprise.EnterpriseUsersProvisionResponse.
 * Use `create(EnterpriseUsersProvisionResponseSchema)` to create a new message.
 */
export const EnterpriseUsersProvisionResponseSchema: GenMessage<EnterpriseUsersProvisionResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 142);

/**
 * @generated from message Enterprise.EnterpriseUsersProvisionResult
 */
export type EnterpriseUsersProvisionResult =
  Message<"Enterprise.EnterpriseUsersProvisionResult"> & {
    /**
     * @generated from field: int64 enterpriseUserId = 1;
     */
    enterpriseUserId: bigint;

    /**
     * @generated from field: string code = 2;
     */
    code: string;

    /**
     * @generated from field: string message = 3;
     */
    message: string;

    /**
     * @generated from field: string additionalInfo = 4;
     */
    additionalInfo: string;
  };

/**
 * Describes the message Enterprise.EnterpriseUsersProvisionResult.
 * Use `create(EnterpriseUsersProvisionResultSchema)` to create a new message.
 */
export const EnterpriseUsersProvisionResultSchema: GenMessage<EnterpriseUsersProvisionResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 143);

/**
 * @generated from message Enterprise.EnterpriseUsersAddRequest
 */
export type EnterpriseUsersAddRequest = Message<"Enterprise.EnterpriseUsersAddRequest"> & {
  /**
   * @generated from field: repeated Enterprise.EnterpriseUsersAdd users = 1;
   */
  users: EnterpriseUsersAdd[];

  /**
   * @generated from field: string clientVersion = 2;
   */
  clientVersion: string;
};

/**
 * Describes the message Enterprise.EnterpriseUsersAddRequest.
 * Use `create(EnterpriseUsersAddRequestSchema)` to create a new message.
 */
export const EnterpriseUsersAddRequestSchema: GenMessage<EnterpriseUsersAddRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 144);

/**
 * @generated from message Enterprise.EnterpriseUsersAdd
 */
export type EnterpriseUsersAdd = Message<"Enterprise.EnterpriseUsersAdd"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: int64 nodeId = 3;
   */
  nodeId: bigint;

  /**
   * @generated from field: string encryptedData = 4;
   */
  encryptedData: string;

  /**
   * @generated from field: Enterprise.EncryptedKeyType keyType = 5;
   */
  keyType: EncryptedKeyType;

  /**
   * @generated from field: string fullName = 6;
   */
  fullName: string;

  /**
   * @generated from field: string jobTitle = 7;
   */
  jobTitle: string;

  /**
   * @generated from field: bool suppressEmailInvite = 8;
   */
  suppressEmailInvite: boolean;

  /**
   * @generated from field: string inviteeLocale = 9;
   */
  inviteeLocale: string;

  /**
   * @generated from field: bool move = 10;
   */
  move: boolean;

  /**
   * @generated from field: int64 roleId = 11;
   */
  roleId: bigint;
};

/**
 * Describes the message Enterprise.EnterpriseUsersAdd.
 * Use `create(EnterpriseUsersAddSchema)` to create a new message.
 */
export const EnterpriseUsersAddSchema: GenMessage<EnterpriseUsersAdd> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 145);

/**
 * @generated from message Enterprise.EnterpriseUsersAddResponse
 */
export type EnterpriseUsersAddResponse = Message<"Enterprise.EnterpriseUsersAddResponse"> & {
  /**
   * @generated from field: repeated Enterprise.EnterpriseUsersAddResult results = 1;
   */
  results: EnterpriseUsersAddResult[];

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: string additionalInfo = 5;
   */
  additionalInfo: string;
};

/**
 * Describes the message Enterprise.EnterpriseUsersAddResponse.
 * Use `create(EnterpriseUsersAddResponseSchema)` to create a new message.
 */
export const EnterpriseUsersAddResponseSchema: GenMessage<EnterpriseUsersAddResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 146);

/**
 * @generated from message Enterprise.EnterpriseUsersAddResult
 */
export type EnterpriseUsersAddResult = Message<"Enterprise.EnterpriseUsersAddResult"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string verificationCode = 3;
   */
  verificationCode: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * @generated from field: string additionalInfo = 6;
   */
  additionalInfo: string;
};

/**
 * Describes the message Enterprise.EnterpriseUsersAddResult.
 * Use `create(EnterpriseUsersAddResultSchema)` to create a new message.
 */
export const EnterpriseUsersAddResultSchema: GenMessage<EnterpriseUsersAddResult> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 147);

/**
 * @generated from message Enterprise.UpdateMSPPermitsRequest
 */
export type UpdateMSPPermitsRequest = Message<"Enterprise.UpdateMSPPermitsRequest"> & {
  /**
   * @generated from field: int32 mspEnterpriseId = 1;
   */
  mspEnterpriseId: number;

  /**
   * @generated from field: int32 maxAllowedLicenses = 2;
   */
  maxAllowedLicenses: number;

  /**
   * @generated from field: repeated string allowedMcProducts = 3;
   */
  allowedMcProducts: string[];

  /**
   * @generated from field: repeated string allowedAddOns = 4;
   */
  allowedAddOns: string[];

  /**
   * @generated from field: string maxFilePlanType = 5;
   */
  maxFilePlanType: string;

  /**
   * @generated from field: bool allowUnlimitedLicenses = 6;
   */
  allowUnlimitedLicenses: boolean;
};

/**
 * Describes the message Enterprise.UpdateMSPPermitsRequest.
 * Use `create(UpdateMSPPermitsRequestSchema)` to create a new message.
 */
export const UpdateMSPPermitsRequestSchema: GenMessage<UpdateMSPPermitsRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 148);

/**
 * @generated from message Enterprise.DeleteEnterpriseUsersRequest
 */
export type DeleteEnterpriseUsersRequest = Message<"Enterprise.DeleteEnterpriseUsersRequest"> & {
  /**
   * @generated from field: repeated int64 enterpriseUserIds = 1;
   */
  enterpriseUserIds: bigint[];
};

/**
 * Describes the message Enterprise.DeleteEnterpriseUsersRequest.
 * Use `create(DeleteEnterpriseUsersRequestSchema)` to create a new message.
 */
export const DeleteEnterpriseUsersRequestSchema: GenMessage<DeleteEnterpriseUsersRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 149);

/**
 * @generated from message Enterprise.DeleteEnterpriseUserStatus
 */
export type DeleteEnterpriseUserStatus = Message<"Enterprise.DeleteEnterpriseUserStatus"> & {
  /**
   * @generated from field: int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint;

  /**
   * @generated from field: Enterprise.DeleteEnterpriseUsersResult status = 2;
   */
  status: DeleteEnterpriseUsersResult;
};

/**
 * Describes the message Enterprise.DeleteEnterpriseUserStatus.
 * Use `create(DeleteEnterpriseUserStatusSchema)` to create a new message.
 */
export const DeleteEnterpriseUserStatusSchema: GenMessage<DeleteEnterpriseUserStatus> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 150);

/**
 * @generated from message Enterprise.DeleteEnterpriseUsersResponse
 */
export type DeleteEnterpriseUsersResponse = Message<"Enterprise.DeleteEnterpriseUsersResponse"> & {
  /**
   * @generated from field: repeated Enterprise.DeleteEnterpriseUserStatus deleteStatus = 1;
   */
  deleteStatus: DeleteEnterpriseUserStatus[];
};

/**
 * Describes the message Enterprise.DeleteEnterpriseUsersResponse.
 * Use `create(DeleteEnterpriseUsersResponseSchema)` to create a new message.
 */
export const DeleteEnterpriseUsersResponseSchema: GenMessage<DeleteEnterpriseUsersResponse> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 151);

/**
 * @generated from message Enterprise.ClearSecurityDataRequest
 */
export type ClearSecurityDataRequest = Message<"Enterprise.ClearSecurityDataRequest"> & {
  /**
   * @generated from field: repeated int64 enterpriseUserId = 1;
   */
  enterpriseUserId: bigint[];

  /**
   * @generated from field: bool allUsers = 2;
   */
  allUsers: boolean;

  /**
   * @generated from field: Enterprise.ClearSecurityDataType type = 3;
   */
  type: ClearSecurityDataType;
};

/**
 * Describes the message Enterprise.ClearSecurityDataRequest.
 * Use `create(ClearSecurityDataRequestSchema)` to create a new message.
 */
export const ClearSecurityDataRequestSchema: GenMessage<ClearSecurityDataRequest> =
  /*@__PURE__*/
  messageDesc(file_enterprise, 152);

/**
 * @generated from enum Enterprise.KeyType
 */
export enum KeyType {
  /**
   * @generated from enum value: RSA = 0;
   */
  RSA = 0,

  /**
   * @generated from enum value: ECC = 1;
   */
  ECC = 1,
}

/**
 * Describes the enum Enterprise.KeyType.
 */
export const KeyTypeSchema: GenEnum<KeyType> = /*@__PURE__*/ enumDesc(file_enterprise, 0);

/**
 * @generated from enum Enterprise.RoleUserModifyStatus
 */
export enum RoleUserModifyStatus {
  /**
   * @generated from enum value: ROLE_EXISTS = 0;
   */
  ROLE_EXISTS = 0,

  /**
   * @generated from enum value: MISSING_TREE_KEY = 1;
   */
  MISSING_TREE_KEY = 1,

  /**
   * @generated from enum value: MISSING_ROLE_KEY = 2;
   */
  MISSING_ROLE_KEY = 2,

  /**
   * @generated from enum value: INVALID_ENTERPRISE_USER_ID = 3;
   */
  INVALID_ENTERPRISE_USER_ID = 3,

  /**
   * @generated from enum value: PENDING_ENTERPRISE_USER = 4;
   */
  PENDING_ENTERPRISE_USER = 4,

  /**
   * @generated from enum value: INVALID_NODE_ID = 5;
   */
  INVALID_NODE_ID = 5,

  /**
   * @generated from enum value: MAY_NOT_REMOVE_SELF_FROM_ROLE = 6;
   */
  MAY_NOT_REMOVE_SELF_FROM_ROLE = 6,

  /**
   * @generated from enum value: MUST_HAVE_ONE_USER_ADMIN = 7;
   */
  MUST_HAVE_ONE_USER_ADMIN = 7,
}

/**
 * Describes the enum Enterprise.RoleUserModifyStatus.
 */
export const RoleUserModifyStatusSchema: GenEnum<RoleUserModifyStatus> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 1);

/**
 * @generated from enum Enterprise.EnterpriseType
 */
export enum EnterpriseType {
  /**
   * @generated from enum value: ENTERPRISE_STANDARD = 0;
   */
  ENTERPRISE_STANDARD = 0,

  /**
   * @generated from enum value: ENTERPRISE_MSP = 1;
   */
  ENTERPRISE_MSP = 1,
}

/**
 * Describes the enum Enterprise.EnterpriseType.
 */
export const EnterpriseTypeSchema: GenEnum<EnterpriseType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 2);

/**
 * @generated from enum Enterprise.TransferAcceptanceStatus
 */
export enum TransferAcceptanceStatus {
  /**
   * @generated from enum value: UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: NOT_REQUIRED = 1;
   */
  NOT_REQUIRED = 1,

  /**
   * @generated from enum value: NOT_ACCEPTED = 2;
   */
  NOT_ACCEPTED = 2,

  /**
   * @generated from enum value: PARTIALLY_ACCEPTED = 3;
   */
  PARTIALLY_ACCEPTED = 3,

  /**
   * @generated from enum value: ACCEPTED = 4;
   */
  ACCEPTED = 4,
}

/**
 * Describes the enum Enterprise.TransferAcceptanceStatus.
 */
export const TransferAcceptanceStatusSchema: GenEnum<TransferAcceptanceStatus> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 3);

/**
 * @generated from enum Enterprise.EnterpriseDataEntity
 */
export enum EnterpriseDataEntity {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NODES = 1;
   */
  NODES = 1,

  /**
   * @generated from enum value: ROLES = 2;
   */
  ROLES = 2,

  /**
   * @generated from enum value: USERS = 3;
   */
  USERS = 3,

  /**
   * @generated from enum value: TEAMS = 4;
   */
  TEAMS = 4,

  /**
   * @generated from enum value: TEAM_USERS = 5;
   */
  TEAM_USERS = 5,

  /**
   * @generated from enum value: ROLE_USERS = 6;
   */
  ROLE_USERS = 6,

  /**
   * @generated from enum value: ROLE_PRIVILEGES = 7;
   */
  ROLE_PRIVILEGES = 7,

  /**
   * @generated from enum value: ROLE_ENFORCEMENTS = 8;
   */
  ROLE_ENFORCEMENTS = 8,

  /**
   * @generated from enum value: ROLE_TEAMS = 9;
   */
  ROLE_TEAMS = 9,

  /**
   * @generated from enum value: LICENSES = 10;
   */
  LICENSES = 10,

  /**
   * @generated from enum value: MANAGED_NODES = 11;
   */
  MANAGED_NODES = 11,

  /**
   * @generated from enum value: MANAGED_COMPANIES = 12;
   */
  MANAGED_COMPANIES = 12,

  /**
   * @generated from enum value: BRIDGES = 13;
   */
  BRIDGES = 13,

  /**
   * @generated from enum value: SCIMS = 14;
   */
  SCIMS = 14,

  /**
   * @generated from enum value: EMAIL_PROVISION = 15;
   */
  EMAIL_PROVISION = 15,

  /**
   * @generated from enum value: QUEUED_TEAMS = 16;
   */
  QUEUED_TEAMS = 16,

  /**
   * @generated from enum value: QUEUED_TEAM_USERS = 17;
   */
  QUEUED_TEAM_USERS = 17,

  /**
   * @generated from enum value: SSO_SERVICES = 18;
   */
  SSO_SERVICES = 18,

  /**
   * @generated from enum value: REPORT_FILTER_USERS = 19;
   */
  REPORT_FILTER_USERS = 19,

  /**
   * @generated from enum value: DEVICES_REQUEST_FOR_ADMIN_APPROVAL = 20;
   */
  DEVICES_REQUEST_FOR_ADMIN_APPROVAL = 20,

  /**
   * @generated from enum value: USER_ALIASES = 21;
   */
  USER_ALIASES = 21,

  /**
   * @generated from enum value: COMPLIANCE_REPORT_CRITERIA_AND_FILTER = 22;
   */
  COMPLIANCE_REPORT_CRITERIA_AND_FILTER = 22,

  /**
   * @generated from enum value: COMPLIANCE_REPORTS = 23;
   */
  COMPLIANCE_REPORTS = 23,

  /**
   * @generated from enum value: QUEUED_TEAM_USERS_INCLUDING_PENDING = 24;
   */
  QUEUED_TEAM_USERS_INCLUDING_PENDING = 24,
}

/**
 * Describes the enum Enterprise.EnterpriseDataEntity.
 */
export const EnterpriseDataEntitySchema: GenEnum<EnterpriseDataEntity> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 4);

/**
 * @generated from enum Enterprise.CacheStatus
 */
export enum CacheStatus {
  /**
   * @generated from enum value: KEEP = 0;
   */
  KEEP = 0,

  /**
   * @generated from enum value: CLEAR = 1;
   */
  CLEAR = 1,
}

/**
 * Describes the enum Enterprise.CacheStatus.
 */
export const CacheStatusSchema: GenEnum<CacheStatus> = /*@__PURE__*/ enumDesc(file_enterprise, 5);

/**
 * @generated from enum Enterprise.BackupKeyType
 */
export enum BackupKeyType {
  /**
   * @generated from enum value: NO_KEY = 0;
   */
  NO_KEY = 0,

  /**
   * @generated from enum value: ENCRYPTED_BY_DATA_KEY = 1;
   */
  ENCRYPTED_BY_DATA_KEY = 1,

  /**
   * @generated from enum value: ENCRYPTED_BY_PUBLIC_KEY = 2;
   */
  ENCRYPTED_BY_PUBLIC_KEY = 2,

  /**
   * @generated from enum value: ENCRYPTED_BY_DATA_KEY_GCM = 3;
   */
  ENCRYPTED_BY_DATA_KEY_GCM = 3,

  /**
   * @generated from enum value: ENCRYPTED_BY_PUBLIC_KEY_ECC = 4;
   */
  ENCRYPTED_BY_PUBLIC_KEY_ECC = 4,
}

/**
 * Describes the enum Enterprise.BackupKeyType.
 */
export const BackupKeyTypeSchema: GenEnum<BackupKeyType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 6);

/**
 * @generated from enum Enterprise.BackupUserDataKeyType
 */
export enum BackupUserDataKeyType {
  /**
   * @generated from enum value: OWN = 0;
   */
  OWN = 0,

  /**
   * @generated from enum value: SHARED_TO_ENTERPRISE = 1;
   */
  SHARED_TO_ENTERPRISE = 1,
}

/**
 * Describes the enum Enterprise.BackupUserDataKeyType.
 */
export const BackupUserDataKeyTypeSchema: GenEnum<BackupUserDataKeyType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 7);

/**
 * @generated from enum Enterprise.EncryptedKeyType
 */
export enum EncryptedKeyType {
  /**
   * @generated from enum value: KT_NO_KEY = 0;
   */
  KT_NO_KEY = 0,

  /**
   * @generated from enum value: KT_ENCRYPTED_BY_DATA_KEY = 1;
   */
  KT_ENCRYPTED_BY_DATA_KEY = 1,

  /**
   * @generated from enum value: KT_ENCRYPTED_BY_PUBLIC_KEY = 2;
   */
  KT_ENCRYPTED_BY_PUBLIC_KEY = 2,

  /**
   * @generated from enum value: KT_ENCRYPTED_BY_DATA_KEY_GCM = 3;
   */
  KT_ENCRYPTED_BY_DATA_KEY_GCM = 3,

  /**
   * @generated from enum value: KT_ENCRYPTED_BY_PUBLIC_KEY_ECC = 4;
   */
  KT_ENCRYPTED_BY_PUBLIC_KEY_ECC = 4,
}

/**
 * Describes the enum Enterprise.EncryptedKeyType.
 */
export const EncryptedKeyTypeSchema: GenEnum<EncryptedKeyType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 8);

/**
 * @generated from enum Enterprise.EnterpriseFlagType
 */
export enum EnterpriseFlagType {
  /**
   * @generated from enum value: INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ALLOW_PERSONAL_LICENSE = 1;
   */
  ALLOW_PERSONAL_LICENSE = 1,

  /**
   * @generated from enum value: SPECIAL_PROVISIONING = 2;
   */
  SPECIAL_PROVISIONING = 2,

  /**
   * @generated from enum value: RECORD_TYPES = 3;
   */
  RECORD_TYPES = 3,

  /**
   * @generated from enum value: SECRETS_MANAGER = 4;
   */
  SECRETS_MANAGER = 4,

  /**
   * @generated from enum value: ENTERPRISE_LOCKED = 5;
   */
  ENTERPRISE_LOCKED = 5,

  /**
   * @generated from enum value: FORBID_KEY_TYPE_2 = 6;
   */
  FORBID_KEY_TYPE_2 = 6,

  /**
   * @generated from enum value: CONSOLE_ONBOARDED = 7;
   */
  CONSOLE_ONBOARDED = 7,

  /**
   * @generated from enum value: FORBID_ACCOUNT_TRANSFER = 8;
   */
  FORBID_ACCOUNT_TRANSFER = 8,

  /**
   * @generated from enum value: NPS_POPUP_OPT_OUT = 9;
   */
  NPS_POPUP_OPT_OUT = 9,

  /**
   * @generated from enum value: SHOW_USER_ONBOARD = 10;
   */
  SHOW_USER_ONBOARD = 10,
}

/**
 * Describes the enum Enterprise.EnterpriseFlagType.
 */
export const EnterpriseFlagTypeSchema: GenEnum<EnterpriseFlagType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 9);

/**
 * @generated from enum Enterprise.UserUpdateStatus
 */
export enum UserUpdateStatus {
  /**
   * @generated from enum value: USER_UPDATE_OK = 0;
   */
  USER_UPDATE_OK = 0,

  /**
   * @generated from enum value: USER_UPDATE_ACCESS_DENIED = 1;
   */
  USER_UPDATE_ACCESS_DENIED = 1,
}

/**
 * Describes the enum Enterprise.UserUpdateStatus.
 */
export const UserUpdateStatusSchema: GenEnum<UserUpdateStatus> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 10);

/**
 * @generated from enum Enterprise.AuditUserStatus
 */
export enum AuditUserStatus {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: ACCESS_DENIED = 1;
   */
  ACCESS_DENIED = 1,

  /**
   * @generated from enum value: NO_LONGER_IN_ENTERPRISE = 2;
   */
  NO_LONGER_IN_ENTERPRISE = 2,
}

/**
 * Describes the enum Enterprise.AuditUserStatus.
 */
export const AuditUserStatusSchema: GenEnum<AuditUserStatus> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 11);

/**
 * @generated from enum Enterprise.TeamUserType
 */
export enum TeamUserType {
  /**
   * @generated from enum value: USER = 0;
   */
  USER = 0,

  /**
   * @generated from enum value: ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: ADMIN_ONLY = 2;
   */
  ADMIN_ONLY = 2,
}

/**
 * Describes the enum Enterprise.TeamUserType.
 */
export const TeamUserTypeSchema: GenEnum<TeamUserType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 12);

/**
 * @generated from enum Enterprise.AppClientType
 */
export enum AppClientType {
  /**
   * @generated from enum value: NOT_USED = 0;
   */
  NOT_USED = 0,

  /**
   * @generated from enum value: GENERAL = 1;
   */
  GENERAL = 1,

  /**
   * @generated from enum value: DISCOVERY_AND_ROTATION_CONTROLLER = 2;
   */
  DISCOVERY_AND_ROTATION_CONTROLLER = 2,

  /**
   * @generated from enum value: KCM_CONTROLLER = 3;
   */
  KCM_CONTROLLER = 3,

  /**
   * @generated from enum value: SELF_DESTRUCT = 4;
   */
  SELF_DESTRUCT = 4,
}

/**
 * Describes the enum Enterprise.AppClientType.
 */
export const AppClientTypeSchema: GenEnum<AppClientType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 13);

/**
 * @generated from enum Enterprise.DeleteEnterpriseUsersResult
 */
export enum DeleteEnterpriseUsersResult {
  /**
   * @generated from enum value: SUCCESS = 0;
   */
  SUCCESS = 0,

  /**
   * @generated from enum value: NOT_AN_ENTERPRISE_USER = 1;
   */
  NOT_AN_ENTERPRISE_USER = 1,

  /**
   * @generated from enum value: CANNOT_DELETE_SELF = 2;
   */
  CANNOT_DELETE_SELF = 2,

  /**
   * @generated from enum value: BRIDGE_CANNOT_DELETE_ACTIVE_USER = 3;
   */
  BRIDGE_CANNOT_DELETE_ACTIVE_USER = 3,

  /**
   * @generated from enum value: ERROR = 4;
   */
  ERROR = 4,
}

/**
 * Describes the enum Enterprise.DeleteEnterpriseUsersResult.
 */
export const DeleteEnterpriseUsersResultSchema: GenEnum<DeleteEnterpriseUsersResult> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 14);

/**
 * @generated from enum Enterprise.ClearSecurityDataType
 */
export enum ClearSecurityDataType {
  /**
   * @generated from enum value: RECALCULATE_SUMMARY_REPORT = 0;
   */
  RECALCULATE_SUMMARY_REPORT = 0,

  /**
   * @generated from enum value: FORCE_CLIENT_CHECK_FOR_MISSING_DATA = 1;
   */
  FORCE_CLIENT_CHECK_FOR_MISSING_DATA = 1,

  /**
   * @generated from enum value: FORCE_CLIENT_RESEND_SECURITY_DATA = 2;
   */
  FORCE_CLIENT_RESEND_SECURITY_DATA = 2,
}

/**
 * Describes the enum Enterprise.ClearSecurityDataType.
 */
export const ClearSecurityDataTypeSchema: GenEnum<ClearSecurityDataType> =
  /*@__PURE__*/
  enumDesc(file_enterprise, 15);
